[
  {
    "identifier": "BP_EM_ADD_COVERIMG",
    "source_string": "Add cover image",
    "translation": "Add cover image",
    "context": " -> BP_EM_ADD_COVERIMG"
  },
  {
    "identifier": "CP_BANNER_DOWNLAOD_NOW",
    "source_string": "Download now",
    "translation": "Download now",
    "context": " -> CP_BANNER_DOWNLAOD_NOW"
  },
  {
    "identifier": "CP_BANNER_HEADING",
    "source_string": "Mercedes-Benz Stories",
    "translation": "Mercedes-Benz Stories",
    "context": " -> CP_BANNER_HEADING"
  },
  {
    "identifier": "CP_BANNER_SUB_HEADING_MOBILE",
    "source_string": "Your digital companion, coach and community.",
    "translation": "Your digital companion, coach and community.",
    "context": " -> CP_BANNER_SUB_HEADING_MOBILE"
  },
  {
    "identifier": "CP_BANNER_SUB_HEADING_TABLET",
    "source_string": "Your digital companion and community – for everything that drives you.",
    "translation": "Your digital companion and community – for everything that drives you.",
    "context": " -> CP_BANNER_SUB_HEADING_TABLET"
  },
  {
    "identifier": "CP_CIAM_GREETING",
    "source_string": "Hello {placeholderOwnerName}!",
    "translation": "Hello {placeholderOwnerName}!",
    "context": " -> CP_CIAM_GREETING"
  },
  {
    "identifier": "CP_CONTENT_NOT_FOUND",
    "source_string": "Sorry, we are unable to load content at the moment. Please try reloading the page.",
    "translation": "Sorry, we are unable to load content at the moment. Please try reloading the page.",
    "context": " -> CP_CONTENT_NOT_FOUND"
  },
  {
    "identifier": "CP_FOOTER_TOP_LBL",
    "source_string": "Top",
    "translation": "Top",
    "context": " -> CP_FOOTER_TOP_LBL"
  },
  {
    "identifier": "CP_GARAGE_NO_STORY_MSG",
    "source_string": " There are no Stories from this car, yet. Use the Mercedes me Stories App to record a ride and publish the Recording. You can also use the app to publish a special Moment with your car.",
    "translation": " There are no Stories from this car, yet. Use the Mercedes me Stories App to record a ride and publish the Recording. You can also use the app to publish a special Moment with your car.",
    "context": " -> CP_GARAGE_NO_STORY_MSG"
  },
  {
    "identifier": "CP_LEGAL_TEMPLATE",
    "source_string": "<div class=\"container\"><div class=\"brandhub-legal-layer__text\"><h4>Copyrights</h4><p>Copyright 2003-2020 Mercedes-Benz AG. All rights reserved. All text, images, graphics, sound files, video files and animation files and their arrangement are subject to copyright and other intellectual property laws. They may not be copied, either for commercial purposes or for redistribution, nor may they be modified and used on other websites. Some Mercedes-Benz Group AG webpages also include material that is subject to the copyright of those parties who have made such material available.</p><h4>Products and prices</h4><p>Some products and services may have changed since individual pages on this website were last edited. The manufacturer reserves the right to make changes to the design, form, color and specification during the delivery period, provided these changes or variations can be deemed reasonable for the customer, while taking into account the interests of Mercedes-Benz Group AG. The illustrations may show accessories, optional equipment or other features which are not part of the standard specification. Colors may differ slightly from those depicted, for technical reasons. Some pages may also feature models and services which are not available in individual countries. Statements regarding legislative, fiscal or other legal regulations and the implications of these are valid only for the Federal Republic of Germany. Subject to any contrary provision in the terms and conditions of sale or delivery, the prices valid on the date of delivery shall apply. For our dealers, the prices are to be regarded as the recommended retail price. Please contact a company-owned sales and service outlet or an authorized dealer to find out current prices.</p><h4>Trademarks</h4><p>Unless otherwise stipulated, all brand names featured on the pages of Mercedes-Benz Group AG websites are legally protected trademarks belonging to Mercedes-Benz Group AG. This applies in particular to the model names and all corporate logos and emblems.</p><h4>Licenses</h4><p>Mercedes-Benz Group AG has sought to bring you an innovative and informative internet site, and we hope that you will be as enthusiastic about our creative effort as we are. Please appreciate, however, that Mercedes-Benz Group AG has to protect its intellectual property, including patents, trademarks and copyrights, and that these internet pages cannot be construed as granting any license rights to Mercedes-Benz Group AG’s intellectual property.</p><h4>Forward-looking statements disclaimer</h4><p>Internet pages, Investor Relations releases, annual and interim reports, outlooks, presentations, audio and video broadcasts of events (live or recorded) and other documents on this website contain, among other things, forward-looking statements about future developments that are based on the current assessments of the management. The words ‘anticipate,’ ‘assume,’ ‘believe,’ ‘estimate,’ ‘expect,’ ‘intend,’ ‘may/might,’ ‘plan,’ ‘project,’ ‘should’ and similar expressions are used to indicate forward-looking statements. Such statements are subject to certain risks and uncertainties, including an economic downturn in Europe or North America, changes in exchange rates, interest rates and raw materials prices, the launch of products by competitors, higher sales incentives, the successful implementation of the new business model for smart, and a decline in resale prices of used vehicles. If any of these risks and uncertainties (some of which are described in Mercedes-Benz Group AG’s most recent Annual Report under the heading ‘Risk Report’ and under the heading ‘Risk Factors’ in Form 20-F, which was submitted to the US Securities and Exchange Commission (SEC)) materialize or if the assumptions underlying any of our forward-looking statements prove incorrect, then our actual results may be materially different from those we express or imply by such statements. We do not intend or assume any obligation to update these forward-looking statements. Any forward-looking statement applies only in relation to the situation prevailing on the date on which it is made.</p><h4>Information according to § 36 German Consumer Dispute Resolution Act (VSBG)</h4><p>Mercedes-Benz Group AG will not participate in a dispute settlement proceeding in front of a consumer arbitration board according to the German Consumer Dispute Resolution Act (VSBG) and is not obliged to do so.</p><h4>Information about online dispute resolution</h4><p>The European Commission has established an internet platform for online dispute resolution (so called “ODR platform”). The ODR platform is a point of entry for out-of-court resolutions relating to contractual obligations of online sales contracts. You can get to the ODR platform by following the link: <a href=\"http://ec.europa.eu/consumers/odr\">http://ec.europa.eu/consumers/odr</a></p><h4>Liability</h4><p>The information provided and the statements made on these pages do not constitute any representation or warranty, either express or implied. In particular such information is not an implied promise or guarantee in respect of quality, marketability, fitness for any particular purpose, or the non-infringement of laws and patents. Our internet pages also contain links to other internet sites. We would like to point out that we have no influence over the design and content of the linked sites. We therefore accept no liability for the accuracy, completeness or quality of the information provided there, nor do we guarantee that it is up to date. Consequently we hereby distance ourselves from all content of such sites. This declaration applies to all links to external sites contained on our internet pages and to the content of such sites.</p></div></div>",
    "translation": "<div class=\"container\"><div class=\"brandhub-legal-layer__text\"><h4>Copyrights</h4><p>Copyright 2003-2020 Mercedes-Benz AG. All rights reserved. All text, images, graphics, sound files, video files and animation files and their arrangement are subject to copyright and other intellectual property laws. They may not be copied, either for commercial purposes or for redistribution, nor may they be modified and used on other websites. Some Mercedes-Benz Group AG webpages also include material that is subject to the copyright of those parties who have made such material available.</p><h4>Products and prices</h4><p>Some products and services may have changed since individual pages on this website were last edited. The manufacturer reserves the right to make changes to the design, form, color and specification during the delivery period, provided these changes or variations can be deemed reasonable for the customer, while taking into account the interests of Mercedes-Benz Group AG. The illustrations may show accessories, optional equipment or other features which are not part of the standard specification. Colors may differ slightly from those depicted, for technical reasons. Some pages may also feature models and services which are not available in individual countries. Statements regarding legislative, fiscal or other legal regulations and the implications of these are valid only for the Federal Republic of Germany. Subject to any contrary provision in the terms and conditions of sale or delivery, the prices valid on the date of delivery shall apply. For our dealers, the prices are to be regarded as the recommended retail price. Please contact a company-owned sales and service outlet or an authorized dealer to find out current prices.</p><h4>Trademarks</h4><p>Unless otherwise stipulated, all brand names featured on the pages of Mercedes-Benz Group AG websites are legally protected trademarks belonging to Mercedes-Benz Group AG. This applies in particular to the model names and all corporate logos and emblems.</p><h4>Licenses</h4><p>Mercedes-Benz Group AG has sought to bring you an innovative and informative internet site, and we hope that you will be as enthusiastic about our creative effort as we are. Please appreciate, however, that Mercedes-Benz Group AG has to protect its intellectual property, including patents, trademarks and copyrights, and that these internet pages cannot be construed as granting any license rights to Mercedes-Benz Group AG’s intellectual property.</p><h4>Forward-looking statements disclaimer</h4><p>Internet pages, Investor Relations releases, annual and interim reports, outlooks, presentations, audio and video broadcasts of events (live or recorded) and other documents on this website contain, among other things, forward-looking statements about future developments that are based on the current assessments of the management. The words ‘anticipate,’ ‘assume,’ ‘believe,’ ‘estimate,’ ‘expect,’ ‘intend,’ ‘may/might,’ ‘plan,’ ‘project,’ ‘should’ and similar expressions are used to indicate forward-looking statements. Such statements are subject to certain risks and uncertainties, including an economic downturn in Europe or North America, changes in exchange rates, interest rates and raw materials prices, the launch of products by competitors, higher sales incentives, the successful implementation of the new business model for smart, and a decline in resale prices of used vehicles. If any of these risks and uncertainties (some of which are described in Mercedes-Benz Group AG’s most recent Annual Report under the heading ‘Risk Report’ and under the heading ‘Risk Factors’ in Form 20-F, which was submitted to the US Securities and Exchange Commission (SEC)) materialize or if the assumptions underlying any of our forward-looking statements prove incorrect, then our actual results may be materially different from those we express or imply by such statements. We do not intend or assume any obligation to update these forward-looking statements. Any forward-looking statement applies only in relation to the situation prevailing on the date on which it is made.</p><h4>Information according to § 36 German Consumer Dispute Resolution Act (VSBG)</h4><p>Mercedes-Benz Group AG will not participate in a dispute settlement proceeding in front of a consumer arbitration board according to the German Consumer Dispute Resolution Act (VSBG) and is not obliged to do so.</p><h4>Information about online dispute resolution</h4><p>The European Commission has established an internet platform for online dispute resolution (so called “ODR platform”). The ODR platform is a point of entry for out-of-court resolutions relating to contractual obligations of online sales contracts. You can get to the ODR platform by following the link: <a href=\"http://ec.europa.eu/consumers/odr\">http://ec.europa.eu/consumers/odr</a></p><h4>Liability</h4><p>The information provided and the statements made on these pages do not constitute any representation or warranty, either express or implied. In particular such information is not an implied promise or guarantee in respect of quality, marketability, fitness for any particular purpose, or the non-infringement of laws and patents. Our internet pages also contain links to other internet sites. We would like to point out that we have no influence over the design and content of the linked sites. We therefore accept no liability for the accuracy, completeness or quality of the information provided there, nor do we guarantee that it is up to date. Consequently we hereby distance ourselves from all content of such sites. This declaration applies to all links to external sites contained on our internet pages and to the content of such sites.</p></div></div>",
    "context": " -> CP_LEGAL_TEMPLATE"
  },
  {
    "identifier": "CP_LM_ANNOTATIONDETAILSPAGE_OVERVIEW",
    "source_string": "Overview",
    "translation": "Overview",
    "context": " -> CP_LM_ANNOTATIONDETAILSPAGE_OVERVIEW"
  },
  {
    "identifier": "CP_LM_ANONYMIZATION_ALREADY_DONE",
    "source_string": "Data already anonymized",
    "translation": "Data already anonymized",
    "context": " -> CP_LM_ANONYMIZATION_ALREADY_DONE"
  },
  {
    "identifier": "CP_LM_ANONYMIZATION_SUCCESS DATA",
    "source_string": "anonymisation successful.",
    "translation": "anonymisation successful.",
    "context": " -> CP_LM_ANONYMIZATION_SUCCESS DATA"
  },
  {
    "identifier": "CP_LM_CIRCUITDETAILSPAGE_ADDRESS",
    "source_string": "Address",
    "translation": "Address",
    "context": " -> CP_LM_CIRCUITDETAILSPAGE_ADDRESS"
  },
  {
    "identifier": "CP_LM_CIRCUITDETAILSPAGE_CIRCUIT",
    "source_string": "Circuit",
    "translation": "Circuit",
    "context": " -> CP_LM_CIRCUITDETAILSPAGE_CIRCUIT"
  },
  {
    "identifier": "CP_LM_CIRCUITDETAILSPAGE_STORIESHEADER",
    "source_string": "Stories from the Community",
    "translation": "Stories from the Community",
    "context": " -> CP_LM_CIRCUITDETAILSPAGE_STORIESHEADER"
  },
  {
    "identifier": "CP_LM_CIRCUITDETAILSPAGE_WEBSITE",
    "source_string": "Website",
    "translation": "Website",
    "context": " -> CP_LM_CIRCUITDETAILSPAGE_WEBSITE"
  },
  {
    "identifier": "CP_LM_DEFAULTPAGE_MESSAGE",
    "source_string": "Page not found",
    "translation": "Page not found",
    "context": " -> CP_LM_DEFAULTPAGE_MESSAGE"
  },
  {
    "identifier": "CP_LM_EDITPROFILE_SUBMESSAGE",
    "source_string": "To modify your Mercedes me account details, kindly visit the official Mercedes-Benz website",
    "translation": "To modify your Mercedes me account details, kindly visit the official Mercedes-Benz website",
    "context": " -> CP_LM_EDITPROFILE_SUBMESSAGE"
  },
  {
    "identifier": "CP_LM_FOOTER_LEGAL",
    "source_string": "Legal",
    "translation": "Legal",
    "context": " -> CP_LM_FOOTER_LEGAL"
  },
  {
    "identifier": "CP_LM_FOOTER_PRIVACY",
    "source_string": "Privacy",
    "translation": "Privacy",
    "context": " -> CP_LM_FOOTER_PRIVACY"
  },
  {
    "identifier": "CP_LM_FOOTER_PROVIDER",
    "source_string": "Provider",
    "translation": "Provider",
    "context": " -> CP_LM_FOOTER_PROVIDER"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_ALL",
    "source_string": "All",
    "translation": "All",
    "context": " -> CP_LM_LANDINGPAGE_ALL"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_ALLANG",
    "source_string": "All languages",
    "translation": "All languages",
    "context": " -> CP_LM_LANDINGPAGE_ALLANG"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_CLOSE",
    "source_string": "Close",
    "translation": "Close",
    "context": " -> CP_LM_LANDINGPAGE_CLOSE"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_CREATE",
    "source_string": "Create",
    "translation": "Create",
    "context": " -> CP_LM_LANDINGPAGE_CREATE"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_EMOTIONTOUR",
    "source_string": "Emotion Tour",
    "translation": "Emotion Tour",
    "context": " -> CP_LM_LANDINGPAGE_EMOTIONTOUR"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_EXPLORE",
    "source_string": "Explore",
    "translation": "Explore",
    "context": " -> CP_LM_LANDINGPAGE_EXPLORE"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_FAVOURITE",
    "source_string": "Favourites",
    "translation": "Favourites",
    "context": " -> CP_LM_LANDINGPAGE_FAVOURITE"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_LIBRARY",
    "source_string": "My Stories",
    "translation": "My Stories",
    "context": " -> CP_LM_LANDINGPAGE_LIBRARY"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_LOGIN",
    "source_string": "Login",
    "translation": "Login",
    "context": " -> CP_LM_LANDINGPAGE_LOGIN"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_LOGOUT",
    "source_string": "Logout",
    "translation": "Logout",
    "context": " -> CP_LM_LANDINGPAGE_LOGOUT"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_MENU",
    "source_string": "Menu",
    "translation": "Menu",
    "context": " -> CP_LM_LANDINGPAGE_MENU"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_MY",
    "source_string": "My",
    "translation": "My",
    "context": " -> CP_LM_LANDINGPAGE_MY"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_MYTRACKS",
    "source_string": "My Tracks",
    "translation": "My Tracks",
    "context": " -> CP_LM_LANDINGPAGE_MYTRACKS"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_NOTFOUND",
    "source_string": "Not Found",
    "translation": "Not Found",
    "context": " -> CP_LM_LANDINGPAGE_NOTFOUND"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_OFFROAD",
    "source_string": "Offroad Track",
    "translation": "Offroad Track",
    "context": " -> CP_LM_LANDINGPAGE_OFFROAD"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_PROFILE",
    "source_string": "Profile",
    "translation": "Profile",
    "context": " -> CP_LM_LANDINGPAGE_PROFILE"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_SEARCHTEXT",
    "source_string": "Search places, landmarks, roads",
    "translation": "Search places, landmarks, roads",
    "context": " -> CP_LM_LANDINGPAGE_SEARCHTEXT"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_SELECTLANG",
    "source_string": "Select Language",
    "translation": "Select Language",
    "context": " -> CP_LM_LANDINGPAGE_SELECTLANG"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_TRACKPACE",
    "source_string": "AMG Track Pace",
    "translation": "AMG Track Pace",
    "context": " -> CP_LM_LANDINGPAGE_TRACKPACE"
  },
  {
    "identifier": "CP_LM_LANDINGPAGE_TRACKS",
    "source_string": "Track",
    "translation": "Track",
    "context": " -> CP_LM_LANDINGPAGE_TRACKS"
  },
  {
    "identifier": "CP_LM_MAINPAGE_BY",
    "source_string": "by",
    "translation": "by",
    "context": " -> CP_LM_MAINPAGE_BY"
  },
  {
    "identifier": "CP_LM_MAINPAGE_LOAD_MORE",
    "source_string": "Load More",
    "translation": "Load More",
    "context": " -> CP_LM_MAINPAGE_LOAD_MORE"
  },
  {
    "identifier": "CP_LM_MAINPAGE_LOGOUT",
    "source_string": "Logout",
    "translation": "Logout",
    "context": " -> CP_LM_MAINPAGE_LOGOUT"
  },
  {
    "identifier": "CP_LM_MAINPAGE_MYPROFILE",
    "source_string": "My profile",
    "translation": "My profile",
    "context": " -> CP_LM_MAINPAGE_MYPROFILE"
  },
  {
    "identifier": "CP_LM_MAINPAGE_MYSTORIES",
    "source_string": "My Stories",
    "translation": "My Stories",
    "context": " -> CP_LM_MAINPAGE_MYSTORIES"
  },
  {
    "identifier": "CP_LM_MAINPAGE_NO_RESULTS",
    "source_string": "No Search Results",
    "translation": "No Search Results",
    "context": " -> CP_LM_MAINPAGE_NO_RESULTS"
  },
  {
    "identifier": "CP_LM_MAINPAGE_WELCOME_LINE1",
    "source_string": "Welcome to Mercedes-Benz Stories.",
    "translation": "Welcome to Mercedes-Benz Stories.",
    "context": " -> CP_LM_MAINPAGE_WELCOME_LINE1"
  },
  {
    "identifier": "CP_LM_MAINPAGE_WELCOME_LINE2",
    "source_string": "Your companion for new adventures",
    "translation": "Your companion for new adventures",
    "context": " -> CP_LM_MAINPAGE_WELCOME_LINE2"
  },
  {
    "identifier": "CP_LM_NOEXPERIENCE_MESSAGE",
    "source_string": "It's too quiet here",
    "translation": "It's too quiet here",
    "context": " -> CP_LM_NOEXPERIENCE_MESSAGE"
  },
  {
    "identifier": "CP_LM_NOEXPERIENCE_SUBMESSAGE",
    "source_string": "Get started on the Mercedes-Benz Stories App, capture and share your experiences with the entire world",
    "translation": "Get started on the Mercedes-Benz Stories App, capture and share your experiences with the entire world",
    "context": " -> CP_LM_NOEXPERIENCE_SUBMESSAGE"
  },
  {
    "identifier": "CP_LM_PAGENOTFOUND_MESSAGE",
    "source_string": "Highlights not available for the tour",
    "translation": "Highlights not available for the tour",
    "context": " -> CP_LM_PAGENOTFOUND_MESSAGE"
  },
  {
    "identifier": "CP_LM_TOAST_MSG_CLUSTER_NOT_FOUND",
    "source_string": "Cluster not found for Tour!",
    "translation": "Cluster not found for Tour!",
    "context": " -> CP_LM_TOAST_MSG_CLUSTER_NOT_FOUND"
  },
  {
    "identifier": "CP_LM_TOAST_MSG_COPIEDTOCLIPBOARD",
    "source_string": "Link copied to clipboard!",
    "translation": "Link copied to clipboard!",
    "context": " -> CP_LM_TOAST_MSG_COPIEDTOCLIPBOARD"
  },
  {
    "identifier": "CP_LM_TOURDETAILSPAGE_ADDFAV",
    "source_string": "Please login to use this feature",
    "translation": "Please login to use this feature",
    "context": " -> CP_LM_TOURDETAILSPAGE_ADDFAV"
  },
  {
    "identifier": "CP_LM_TOURDETAILSPAGE_FROMSTART",
    "source_string": "km from start",
    "translation": "km from start",
    "context": " -> CP_LM_TOURDETAILSPAGE_FROMSTART"
  },
  {
    "identifier": "CP_LM_TOURDETAILSPAGE_HIGHLIGHTS",
    "source_string": "Highlights",
    "translation": "Highlights",
    "context": " -> CP_LM_TOURDETAILSPAGE_HIGHLIGHTS"
  },
  {
    "identifier": "CP_LM_TOURDETAILSPAGE_MEMORIAL",
    "source_string": "Memorial",
    "translation": "Memorial",
    "context": " -> CP_LM_TOURDETAILSPAGE_MEMORIAL"
  },
  {
    "identifier": "CP_LM_TOURDETAILSPAGE_MORE",
    "source_string": "More",
    "translation": "More",
    "context": " -> CP_LM_TOURDETAILSPAGE_MORE"
  },
  {
    "identifier": "CP_LM_TOURDETAILSPAGE_SHARE",
    "source_string": "Share link",
    "translation": "Share link",
    "context": " -> CP_LM_TOURDETAILSPAGE_SHARE"
  },
  {
    "identifier": "CP_LM_TOURDETAILSPAGE_TOURBY",
    "source_string": "Tour by",
    "translation": "Tour by",
    "context": " -> CP_LM_TOURDETAILSPAGE_TOURBY"
  },
  {
    "identifier": "CP_LM_TRACKDETAILSPAGE_SECTORS",
    "source_string": "sectors",
    "translation": "sectors",
    "context": " -> CP_LM_TRACKDETAILSPAGE_SECTORS"
  },
  {
    "identifier": "CP_MOMENT_LOC_AND_VEHICLE",
    "source_string": "Location and vehicle",
    "translation": "Location and vehicle",
    "context": " -> CP_MOMENT_LOC_AND_VEHICLE"
  },
  {
    "identifier": "CP_MOMENT_LOCATION",
    "source_string": "Location",
    "translation": "Location",
    "context": " -> CP_MOMENT_LOCATION"
  },
  {
    "identifier": "CP_MOMENT_PHOTOSHOOT_LBL",
    "source_string": "<strong>{placeholderOwnerName}</strong> - Moment",
    "translation": "<strong>{placeholderOwnerName}</strong> - Moment",
    "context": " -> CP_MOMENT_PHOTOSHOOT_LBL"
  },
  {
    "identifier": "CP_PENDING_VIDEO_MSG",
    "source_string": "We are working on a little extra for this experience. This takes a few minutes, check back later.",
    "translation": "We are working on a little extra for this experience. This takes a few minutes, check back later.",
    "context": " -> CP_PENDING_VIDEO_MSG"
  },
  {
    "identifier": "CP_PRIVACY_TEMPLATE",
    "source_string": "<div class=\"container\"><div class=\"brandhub-legal-layer__text\"><p>&nbsp;</p><h4>The controller as per the EU General Data Protection Regulation (GDPR) is:</h4>\n<p> \nMercedes-Benz AG („We“)<br>\nMercedesstraße 120<br>\n70372 Stuttgart<br>\nGermany<br>\nE-Mail: <a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a>\n</p>\n<h4>Data Protection Officer:</h4>\n<p>Mercedes-Benz Group AG<br>\nChief Officer Corporate Data Protection<br>\nHPC W079<br>\n70546 Stuttgart<br>\nGermany<br>\nE-Mail: <a href=\"mailto:data.protection@mercedes-benz.com\">data.protection@mercedes-benz.com</a>\n</p>\n<h4>1. Data protection</h4>\n<p>We are pleased about your visit on our web pages and your interest in our offers. The pro-tection of your personal data is an important concern for us. In these Privacy Statement we explain how we collect your personal data, what we do with it, for what purposes and on what legal basis this is done, and which rights and claims are associated with it for you. In addition, we refer to the Mercedes-Benz Data Protection Policy: <a href=\"https://group.mercedes-benz.com/data-protection-policy\" target=\"_blank\" rel=\"noopener noreferrer\">Mercedes-Benz Data Protection Policy.</a> </p>\n<p>Our Privacy Statement for the use of our websites and the Data Protection Policy of Mer-cedes-Benz Group AG do not apply to your activities on the websites of social networks or other providers that you can reach via the links on our websites. Please check the websites of these providers for their data protection regulations.</p>\n<h4>2. Collection and processing of your personal data</h4>\n<p>a. When you visit our website, we store certain information about the browser and operat-ing system you use, the date and time of your visit, the access status (e.g. whether you were able to access a website or received an error message), the use of website functions, the search terms you may have entered, the frequency with which you access individual websites, the designation of files accessed, the amount of data transferred, the website from which you accessed our websites and the website which you visit from our websites, either by clicking on links on our websites or by entering a do-main directly in the input field of the same tab (or the same window) of your browser in which you opened our websites. We also store your IP ad-dress and the name of your Internet service provider for seven days for security reasons, in particular to prevent and detect attacks on our websites or attempts at fraud. </p>\n<p>b. We only store other personal data if you provide this data, e.g. as part of a registration, a contact form, a survey, a price competition or for the execution of a contract, and even in these cases only insofar as this is permitted to us on the basis of a consent given by you or in accordance with the applicable legal provisions (further information on this can be found below in the section \"Legal bases of processing\").</p>\n<p>c. You are not legally or contractually obliged to make available your personal data. How-ever, it is possible that certain functions of our websites depend on the availability of personal data. If you do not make available personal data in these cases, this may result in functions not being available or only being available to a limited extent. </p>\n<h4>3. Purposes of use </h4>\n<p>a. We use the personal data collected when you visit our website in order to operate it in the most convenient manner for your use and to protect our IT systems from attacks and other illegal activities.  </p>\n<p>b. If you provide us with further personal data, e.g. within the scope of a registration, a con-tact form, a survey, a price competition or for the execution of a contract, we use this data for the purposes mentioned, for the purposes of customer administration and - if necessary - for the purposes of processing and accounting of any business transactions, in each case to the extent required for this. </p>\n<h4>4.  Transfer of personal data to third parties; social plug-ins; use of service provid-ers </h4>\n<p>a. Our websites may also contain an offer of third parties. If you click on such an offer, we transfer data to the respective provider to the required extent (e.g. information that you have found this offer with us and, if applicable, further information that you have already provided on our websites for this purpose). </p>\n<p>b. When we use social plug-ins on our websites from social networks such as Facebook and Twitter, we integrate them as follows: </p>\n<p>When you visit our websites, the social plug-ins are deactivated, i.e. no data is transmitted to the operators of these networks. If you want to use one of the networks, click on the respec-tive social plug-in to establish a direct connection to the server of the respective network. </p>\n<p>If you have a user account on the network and are logged in when you activate the social plug-in, the network can associate your visit to our websites with your user account. If you want to avoid this, please log out of the network before activating the social plug-in. A social network cannot associate a visit to other Mercedes-Benz websites until you have activated an existing social plug-in. </p>\n<p>When you activate a social plug-in, the network transfers the content that becomes availa-ble directly to your browser, which integrates it into our websites. In this situation, data trans-missions can also take place that are initiated and controlled by the respective social network. Your connection to a social network, the data transfers taking place between the network and your system, and your interactions on that platform are governed sole-ly by the privacy policies of that network. </p>\n<p>The social plug-in remains active until you deactivate it or delete your cookies. </p>\n<p>c. If you click on the link to an offer or activate a social plug-in, personal data may reach providers in countries outside the European Economic Area that, from the point of view of the European Union (\"EU\"), may not guarantee an \"adequate level of protection\" for the processing of personal data in accordance with EU standards. Please remember this fact before clicking on a link or activating a social plug-in and thereby triggering a transfer of your data. </p>\n<p>d. We also use qualified service providers (IT service providers, marketing agencies) to operate, optimize and secure our websites. We only pass on personal data to third parties if and to the extent necessary for the provision and use of the websites and their functionalities, for the pursuit of legitimate interests or if you have consented to it (see section “Legal bases of processing” below). </p>\n<h4>5. Security</h4>\n<p>We use technical and organisational security measures to protect your data managed by us against manipulation, loss, destruction and against access by unauthorised persons. We are constantly improving our security measures in line with technological developments. </p>\n<h4>6. Legal bases of processing </h4>\n<p>a. Insofar as you have given us your consent for the processing of your personal data, that consent is the legal basis for the processing (Art. 6 para. 1 letter a GDPR). </p>\n<p>b. For the processing of personal data for the purposes of initiating or fulfilling a contract with you, Art. 6 para. 1 letter b GDPR is the legal basis. </p>\n<p>c. Insofar as the processing of your personal data is necessary for the fulfilment of our le-gal obligations (e.g. for the retention of data), we are authorized to do so pursuant to Art. 6 para. 1 letter c GDPR.</p>\n<p>d. In addition, we process personal data for the purposes of safeguarding our legitimate interests and the legitimate interests of third parties pursuant to Art. 6 para. 1 letter f GDPR. Maintaining the functionality of our IT systems, (direct-) marketing our own and third-party products and services as well as documenting business contacts as required by law are such legitimate interests. As part of the consideration of interests required in each case, we take into account various aspects, in particular the type of personal information, the purpose of pro-cessing, the circumstances of processing and your interest in the confidentiality of your per-sonal information. </p>\n<h4>7. Deletion of your personal data</h4>\n<p>Your IP address and the name of your Internet service provider, which we only store for security reasons, will be deleted after seven days. Otherwise, we delete your personal data as soon as the purpose for which we have collected and processed the data ceases to apply. Beyond this time period, data storage only takes place to the extent made necessary by the legislation, regulations or other legal provisions to which we are subject in the EU or by legal provisions in third-party countries if these have an appropriate level of data protection. Should it not be possible to delete data in individual cases, the relevant personal data are flagged to restrict their further processing. </p>\n<h4>8. Rights of the data subject</h4>\n<p>a. As a data subject, you have the right of access (Art. 15 GDPR), right to rectification (Art. 16 GDPR), right to erasure (Art. 17 GDPR), right to restriction of processing (Art. 18 GDPR) and right to data portability (Art. 20 GDPR). </p>\n<p>b. If you have consented to the processing of your personal data by us, you have the right to revoke your consent at any time. The legality of processing your personal data before revo-cation remains unaffected. We may further process such data pursuant to another applicable legal basis, e.g. for the fulfilment of our legal obligations (see section \"Legal bases of pro-cessing\").</p>\n<p><u>c. Right to object \n You have the right to object at any time to the processing of your personal data pursuant to Art. 6 para. 1 letter e GDPR (data processing in the public interest) or Art. 6 para. 1 letter f GDPR (data processing on the basis of a balance of interests) on grounds relating to your par-ticular situation. If you object, we will only process your personal data if we can prove compel-ling legitimate reasons that outweigh your interests, rights and freedoms, or for the establish-ment, exercise or defence of legal claims. To the extent we process your personal data for direct marketing purposes, you have the right to object thereto at any time without giving rea-sons. </u></p>\n<p>d. We ask you to address your claims or declarations to the following contact address if possible: <a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a>. </p>\n<p>e. If you believe that the processing of your personal data violates legal requirements, you have the right to lodge a complaint with a competent data protection supervisory authority (Art. 77 GDPR). </p>\n<h4>9. Newsletter</h4>\n<p>If you subscribe to a newsletter offered on our website, the data provided in the newsletter subscription will only be used for sending the newsletter, unless you agree to further use. You can unsubscribe at any time using the unsubscribe option provided in the newsletter. </p>\n<h4>10. Central Access Service of Mercedes-Benz Group AG</h4>\n<p>With the Central Registration Service offered by Mercedes-Benz Group AG, you can sign up for every website and application belonging to the Mercedes-Benz Group and its brands that are connected to the service. The applicable terms of use contain specific data protection provisions. Those terms of use can be found on the registration pages of affiliated websites and applications. </p>\n<h4>11. Data transmission to recipients outside the European Economic Area</h4>\n<p>a. When using service providers (see section “Use of service providers”), personal data may be transferred and processed by recipients in countries outside the European Union (\"EU\"), Iceland, Liechtenstein and Norway (= European Economic Area). </p>\n<p>b. From the point of view of the EU, the following countries provide an adequate level of protection for the processing of personal data in accordance with EU standards (so-called ad-equacy decision): Andorra, Argentina, Canada (limited), Faroe Islands, Guernsey, Israel, Isle of Man, Japan, Jersey, New Zealand, South-Korea, Switzerland, United Kingdom, United States of America (limited), Uruguay. We agree with recipients in other countries to apply EU standard contractual clauses, binding company regulations or other applicable instruments (if any) in order to create an appropriate level of protection in accordance with the legal require-ments. For more information, please use the contact details given in the section “Rights of the data subject” above. </p><p>&nbsp;</p></div></div>",
    "translation": "<div class=\"container\"><div class=\"brandhub-legal-layer__text\"><p>&nbsp;</p><h4>The controller as per the EU General Data Protection Regulation (GDPR) is:</h4>\n<p> \nMercedes-Benz AG („We“)<br>\nMercedesstraße 120<br>\n70372 Stuttgart<br>\nGermany<br>\nE-Mail: <a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a>\n</p>\n<h4>Data Protection Officer:</h4>\n<p>Mercedes-Benz Group AG<br>\nChief Officer Corporate Data Protection<br>\nHPC W079<br>\n70546 Stuttgart<br>\nGermany<br>\nE-Mail: <a href=\"mailto:data.protection@mercedes-benz.com\">data.protection@mercedes-benz.com</a>\n</p>\n<h4>1. Data protection</h4>\n<p>We are pleased about your visit on our web pages and your interest in our offers. The pro-tection of your personal data is an important concern for us. In these Privacy Statement we explain how we collect your personal data, what we do with it, for what purposes and on what legal basis this is done, and which rights and claims are associated with it for you. In addition, we refer to the Mercedes-Benz Data Protection Policy: <a href=\"https://group.mercedes-benz.com/data-protection-policy\" target=\"_blank\" rel=\"noopener noreferrer\">Mercedes-Benz Data Protection Policy.</a> </p>\n<p>Our Privacy Statement for the use of our websites and the Data Protection Policy of Mer-cedes-Benz Group AG do not apply to your activities on the websites of social networks or other providers that you can reach via the links on our websites. Please check the websites of these providers for their data protection regulations.</p>\n<h4>2. Collection and processing of your personal data</h4>\n<p>a. When you visit our website, we store certain information about the browser and operat-ing system you use, the date and time of your visit, the access status (e.g. whether you were able to access a website or received an error message), the use of website functions, the search terms you may have entered, the frequency with which you access individual websites, the designation of files accessed, the amount of data transferred, the website from which you accessed our websites and the website which you visit from our websites, either by clicking on links on our websites or by entering a do-main directly in the input field of the same tab (or the same window) of your browser in which you opened our websites. We also store your IP ad-dress and the name of your Internet service provider for seven days for security reasons, in particular to prevent and detect attacks on our websites or attempts at fraud. </p>\n<p>b. We only store other personal data if you provide this data, e.g. as part of a registration, a contact form, a survey, a price competition or for the execution of a contract, and even in these cases only insofar as this is permitted to us on the basis of a consent given by you or in accordance with the applicable legal provisions (further information on this can be found below in the section \"Legal bases of processing\").</p>\n<p>c. You are not legally or contractually obliged to make available your personal data. How-ever, it is possible that certain functions of our websites depend on the availability of personal data. If you do not make available personal data in these cases, this may result in functions not being available or only being available to a limited extent. </p>\n<h4>3. Purposes of use </h4>\n<p>a. We use the personal data collected when you visit our website in order to operate it in the most convenient manner for your use and to protect our IT systems from attacks and other illegal activities.  </p>\n<p>b. If you provide us with further personal data, e.g. within the scope of a registration, a con-tact form, a survey, a price competition or for the execution of a contract, we use this data for the purposes mentioned, for the purposes of customer administration and - if necessary - for the purposes of processing and accounting of any business transactions, in each case to the extent required for this. </p>\n<h4>4.  Transfer of personal data to third parties; social plug-ins; use of service provid-ers </h4>\n<p>a. Our websites may also contain an offer of third parties. If you click on such an offer, we transfer data to the respective provider to the required extent (e.g. information that you have found this offer with us and, if applicable, further information that you have already provided on our websites for this purpose). </p>\n<p>b. When we use social plug-ins on our websites from social networks such as Facebook and Twitter, we integrate them as follows: </p>\n<p>When you visit our websites, the social plug-ins are deactivated, i.e. no data is transmitted to the operators of these networks. If you want to use one of the networks, click on the respec-tive social plug-in to establish a direct connection to the server of the respective network. </p>\n<p>If you have a user account on the network and are logged in when you activate the social plug-in, the network can associate your visit to our websites with your user account. If you want to avoid this, please log out of the network before activating the social plug-in. A social network cannot associate a visit to other Mercedes-Benz websites until you have activated an existing social plug-in. </p>\n<p>When you activate a social plug-in, the network transfers the content that becomes availa-ble directly to your browser, which integrates it into our websites. In this situation, data trans-missions can also take place that are initiated and controlled by the respective social network. Your connection to a social network, the data transfers taking place between the network and your system, and your interactions on that platform are governed sole-ly by the privacy policies of that network. </p>\n<p>The social plug-in remains active until you deactivate it or delete your cookies. </p>\n<p>c. If you click on the link to an offer or activate a social plug-in, personal data may reach providers in countries outside the European Economic Area that, from the point of view of the European Union (\"EU\"), may not guarantee an \"adequate level of protection\" for the processing of personal data in accordance with EU standards. Please remember this fact before clicking on a link or activating a social plug-in and thereby triggering a transfer of your data. </p>\n<p>d. We also use qualified service providers (IT service providers, marketing agencies) to operate, optimize and secure our websites. We only pass on personal data to third parties if and to the extent necessary for the provision and use of the websites and their functionalities, for the pursuit of legitimate interests or if you have consented to it (see section “Legal bases of processing” below). </p>\n<h4>5. Security</h4>\n<p>We use technical and organisational security measures to protect your data managed by us against manipulation, loss, destruction and against access by unauthorised persons. We are constantly improving our security measures in line with technological developments. </p>\n<h4>6. Legal bases of processing </h4>\n<p>a. Insofar as you have given us your consent for the processing of your personal data, that consent is the legal basis for the processing (Art. 6 para. 1 letter a GDPR). </p>\n<p>b. For the processing of personal data for the purposes of initiating or fulfilling a contract with you, Art. 6 para. 1 letter b GDPR is the legal basis. </p>\n<p>c. Insofar as the processing of your personal data is necessary for the fulfilment of our le-gal obligations (e.g. for the retention of data), we are authorized to do so pursuant to Art. 6 para. 1 letter c GDPR.</p>\n<p>d. In addition, we process personal data for the purposes of safeguarding our legitimate interests and the legitimate interests of third parties pursuant to Art. 6 para. 1 letter f GDPR. Maintaining the functionality of our IT systems, (direct-) marketing our own and third-party products and services as well as documenting business contacts as required by law are such legitimate interests. As part of the consideration of interests required in each case, we take into account various aspects, in particular the type of personal information, the purpose of pro-cessing, the circumstances of processing and your interest in the confidentiality of your per-sonal information. </p>\n<h4>7. Deletion of your personal data</h4>\n<p>Your IP address and the name of your Internet service provider, which we only store for security reasons, will be deleted after seven days. Otherwise, we delete your personal data as soon as the purpose for which we have collected and processed the data ceases to apply. Beyond this time period, data storage only takes place to the extent made necessary by the legislation, regulations or other legal provisions to which we are subject in the EU or by legal provisions in third-party countries if these have an appropriate level of data protection. Should it not be possible to delete data in individual cases, the relevant personal data are flagged to restrict their further processing. </p>\n<h4>8. Rights of the data subject</h4>\n<p>a. As a data subject, you have the right of access (Art. 15 GDPR), right to rectification (Art. 16 GDPR), right to erasure (Art. 17 GDPR), right to restriction of processing (Art. 18 GDPR) and right to data portability (Art. 20 GDPR). </p>\n<p>b. If you have consented to the processing of your personal data by us, you have the right to revoke your consent at any time. The legality of processing your personal data before revo-cation remains unaffected. We may further process such data pursuant to another applicable legal basis, e.g. for the fulfilment of our legal obligations (see section \"Legal bases of pro-cessing\").</p>\n<p><u>c. Right to object \n You have the right to object at any time to the processing of your personal data pursuant to Art. 6 para. 1 letter e GDPR (data processing in the public interest) or Art. 6 para. 1 letter f GDPR (data processing on the basis of a balance of interests) on grounds relating to your par-ticular situation. If you object, we will only process your personal data if we can prove compel-ling legitimate reasons that outweigh your interests, rights and freedoms, or for the establish-ment, exercise or defence of legal claims. To the extent we process your personal data for direct marketing purposes, you have the right to object thereto at any time without giving rea-sons. </u></p>\n<p>d. We ask you to address your claims or declarations to the following contact address if possible: <a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a>. </p>\n<p>e. If you believe that the processing of your personal data violates legal requirements, you have the right to lodge a complaint with a competent data protection supervisory authority (Art. 77 GDPR). </p>\n<h4>9. Newsletter</h4>\n<p>If you subscribe to a newsletter offered on our website, the data provided in the newsletter subscription will only be used for sending the newsletter, unless you agree to further use. You can unsubscribe at any time using the unsubscribe option provided in the newsletter. </p>\n<h4>10. Central Access Service of Mercedes-Benz Group AG</h4>\n<p>With the Central Registration Service offered by Mercedes-Benz Group AG, you can sign up for every website and application belonging to the Mercedes-Benz Group and its brands that are connected to the service. The applicable terms of use contain specific data protection provisions. Those terms of use can be found on the registration pages of affiliated websites and applications. </p>\n<h4>11. Data transmission to recipients outside the European Economic Area</h4>\n<p>a. When using service providers (see section “Use of service providers”), personal data may be transferred and processed by recipients in countries outside the European Union (\"EU\"), Iceland, Liechtenstein and Norway (= European Economic Area). </p>\n<p>b. From the point of view of the EU, the following countries provide an adequate level of protection for the processing of personal data in accordance with EU standards (so-called ad-equacy decision): Andorra, Argentina, Canada (limited), Faroe Islands, Guernsey, Israel, Isle of Man, Japan, Jersey, New Zealand, South-Korea, Switzerland, United Kingdom, United States of America (limited), Uruguay. We agree with recipients in other countries to apply EU standard contractual clauses, binding company regulations or other applicable instruments (if any) in order to create an appropriate level of protection in accordance with the legal require-ments. For more information, please use the contact details given in the section “Rights of the data subject” above. </p><p>&nbsp;</p></div></div>",
    "context": " -> CP_PRIVACY_TEMPLATE"
  },
  {
    "identifier": "CP_PROVIDER_TEMPLATE",
    "source_string": "<div class=\"container\"><div class=\"brandhub-legal-layer__text\"><h4>Mercedes-Benz AG</h4><p>Mercedesstraße 120<br>70372 Stuttgart<br>Germany<br></p><p>Phone: +49 7 11 17-0<br>E-Mail:&nbsp;<a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a></p><p><b>Please send queries about content on this website to any contact. You can address your concerns to us in English or your respective national language.</b></p><p>Represented by the Board of Management:</p><p>Ola Källenius (Chairman), Jörg Burzer, Renata Jungo Brüngger, Sabine Kohleisen, Harald Wilhelm, Markus Schäfer, Britta Seeger,&nbsp;Hubertus Troska</p><p>Chairman of the Supervisory Board:&nbsp;Bernd Pischetsrieder</p><p>Court of Registry: Stuttgart; commercial register no. 76 2873</p><p>VAT ID: DE321281763</p><h4>Provider of Mercedes-Benz Classic-Magazin contents</h4><p>Publisher of Mercedes-Benz Classic-Magazin:<br>Mercedes-Benz AG<br>Mercedesstraße 120<br>70327 Stuttgart, Germany<br><br>Address of editorial department:<u><br> </u>Mercedes-Benz AG<br>Mercedes-Benz Classic Magazine<br>HPC L538<br>70546 Stuttgart, Germany<br><a href=\"mailto:classic.magazin@mercedes-benz.com\">classic.magazin@mercedes-benz.com</a><br><u><br> </u>Responsible on behalf of the publisher:<u><br> </u>Matthias Brock, Karin Buchmann, Simone Wilhelm<br><br>Concept and realisation:<u><br> </u>Looping Group, a brand of Orlando GmbH<br>Prannerstraße 11<br>80333 Munich, Germany<br><br>Editor in Chief: Jörg Heuer<br>Documentation: Dr. Thomas Giesefeld<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>Rights:<br>The magazine, the internet presence and all contributions and&nbsp;Illustrations contained therein are protected by copyright.<br>With the exception of the legally&nbsp;permitted cases, any exploitation without the consent of the publisher&nbsp;and the publishing company is a punishable offence. Articles bearing the name or signet of the author&nbsp;do not necessarily represent the opinion of the publisher&nbsp;or the editorial office.<br>The addresses listed are examples and not&nbsp;Mercedes-Benz Classic recommendations.<br>No liability is assumed for unsolicited&nbsp;manuscripts, photos and data carriers.<br>&nbsp;</p><h2>Other companies advertising on this website:</h2><h4>Provider of Mercedes-Benz Group contents</h4><p>Mercedes-Benz Group AG</p><p>Mercedesstraße 120<br>D-70372 Stuttgart<br>Germany</p><p>Phone: +49 7 11 17-0<br>E-Mail:&nbsp;<a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a></p><p>Represented by the Board of Management:</p><p>Ola Källenius (Chairman), Jörg Burzer, Renata Jungo Brüngger, Sabine Kohleisen, Harald Wilhelm, Markus Schäfer, Britta Seeger,&nbsp;Hubertus Troska</p><p>Chairman of the Supervisory Board:&nbsp;Bernd Pischetsrieder</p><p>Court of Registry: Stuttgart; commercial register no. 19 360</p><p>VAT ID: DE812526315</p><p>&nbsp;</p><h4>Provider of Mercedes-Benz Museum and Mercedes-Benz Classic contents</h4><p>Mercedes-Benz Heritage GmbH<br>Ein Unternehmen der Mercedes-Benz Group AG</p><p>Mercedesstraße 100<br>D-70372 Stuttgart<br>Germany<br></p><p>Phone: +49(0)711-17 30 000<br>Fax: +49(0)711-17 30 400<br>E-Mail: <a href=\"mailto:dialog@mercedes-benz.com\">classic@mercedes-benz.com</a></p><p>Managing Directors:&nbsp;Marcus Breitschwerdt (Chairman), Bettina Haussmann, Alexandra Süß,<b>&nbsp;</b>Andreas Theel</p><p>Court of Registry: Stuttgart; commercial register no. 23 165</p><p>VAT ID: DE 223101663<br><br>&nbsp;</p><h4>Provider of Mercedes-Benz Energy contents</h4><p>Mercedes-Benz Energy GmbH<br>Ein Unternehmen der Mercedes-Benz AG</p><p>Prof.-Gottfried-Bombach-Straße 1<br>D-01917 Kamenz<br>Germany<br><br>E-Mail: <a href=\"mailto:dialog@mercedes-benz.com\">energy-info@mercedes-benz.com</a></p><p>Managing Director: Norman Möhler, Loreen Kramer<br></p><p>Court of Registry: Dresden; commercial register no. 35 530</p><p>VAT ID: DE 299767583<br><br>&nbsp;</p></div></div>",
    "translation": "<div class=\"container\"><div class=\"brandhub-legal-layer__text\"><h4>Mercedes-Benz AG</h4><p>Mercedesstraße 120<br>70372 Stuttgart<br>Germany<br></p><p>Phone: +49 7 11 17-0<br>E-Mail:&nbsp;<a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a></p><p><b>Please send queries about content on this website to any contact. You can address your concerns to us in English or your respective national language.</b></p><p>Represented by the Board of Management:</p><p>Ola Källenius (Chairman), Jörg Burzer, Renata Jungo Brüngger, Sabine Kohleisen, Harald Wilhelm, Markus Schäfer, Britta Seeger,&nbsp;Hubertus Troska</p><p>Chairman of the Supervisory Board:&nbsp;Bernd Pischetsrieder</p><p>Court of Registry: Stuttgart; commercial register no. 76 2873</p><p>VAT ID: DE321281763</p><h4>Provider of Mercedes-Benz Classic-Magazin contents</h4><p>Publisher of Mercedes-Benz Classic-Magazin:<br>Mercedes-Benz AG<br>Mercedesstraße 120<br>70327 Stuttgart, Germany<br><br>Address of editorial department:<u><br> </u>Mercedes-Benz AG<br>Mercedes-Benz Classic Magazine<br>HPC L538<br>70546 Stuttgart, Germany<br><a href=\"mailto:classic.magazin@mercedes-benz.com\">classic.magazin@mercedes-benz.com</a><br><u><br> </u>Responsible on behalf of the publisher:<u><br> </u>Matthias Brock, Karin Buchmann, Simone Wilhelm<br><br>Concept and realisation:<u><br> </u>Looping Group, a brand of Orlando GmbH<br>Prannerstraße 11<br>80333 Munich, Germany<br><br>Editor in Chief: Jörg Heuer<br>Documentation: Dr. Thomas Giesefeld<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br>Rights:<br>The magazine, the internet presence and all contributions and&nbsp;Illustrations contained therein are protected by copyright.<br>With the exception of the legally&nbsp;permitted cases, any exploitation without the consent of the publisher&nbsp;and the publishing company is a punishable offence. Articles bearing the name or signet of the author&nbsp;do not necessarily represent the opinion of the publisher&nbsp;or the editorial office.<br>The addresses listed are examples and not&nbsp;Mercedes-Benz Classic recommendations.<br>No liability is assumed for unsolicited&nbsp;manuscripts, photos and data carriers.<br>&nbsp;</p><h2>Other companies advertising on this website:</h2><h4>Provider of Mercedes-Benz Group contents</h4><p>Mercedes-Benz Group AG</p><p>Mercedesstraße 120<br>D-70372 Stuttgart<br>Germany</p><p>Phone: +49 7 11 17-0<br>E-Mail:&nbsp;<a href=\"mailto:dialog@mercedes-benz.com\">dialog@mercedes-benz.com</a></p><p>Represented by the Board of Management:</p><p>Ola Källenius (Chairman), Jörg Burzer, Renata Jungo Brüngger, Sabine Kohleisen, Harald Wilhelm, Markus Schäfer, Britta Seeger,&nbsp;Hubertus Troska</p><p>Chairman of the Supervisory Board:&nbsp;Bernd Pischetsrieder</p><p>Court of Registry: Stuttgart; commercial register no. 19 360</p><p>VAT ID: DE812526315</p><p>&nbsp;</p><h4>Provider of Mercedes-Benz Museum and Mercedes-Benz Classic contents</h4><p>Mercedes-Benz Heritage GmbH<br>Ein Unternehmen der Mercedes-Benz Group AG</p><p>Mercedesstraße 100<br>D-70372 Stuttgart<br>Germany<br></p><p>Phone: +49(0)711-17 30 000<br>Fax: +49(0)711-17 30 400<br>E-Mail: <a href=\"mailto:dialog@mercedes-benz.com\">classic@mercedes-benz.com</a></p><p>Managing Directors:&nbsp;Marcus Breitschwerdt (Chairman), Bettina Haussmann, Alexandra Süß,<b>&nbsp;</b>Andreas Theel</p><p>Court of Registry: Stuttgart; commercial register no. 23 165</p><p>VAT ID: DE 223101663<br><br>&nbsp;</p><h4>Provider of Mercedes-Benz Energy contents</h4><p>Mercedes-Benz Energy GmbH<br>Ein Unternehmen der Mercedes-Benz AG</p><p>Prof.-Gottfried-Bombach-Straße 1<br>D-01917 Kamenz<br>Germany<br><br>E-Mail: <a href=\"mailto:dialog@mercedes-benz.com\">energy-info@mercedes-benz.com</a></p><p>Managing Director: Norman Möhler, Loreen Kramer<br></p><p>Court of Registry: Dresden; commercial register no. 35 530</p><p>VAT ID: DE 299767583<br><br>&nbsp;</p></div></div>",
    "context": " -> CP_PROVIDER_TEMPLATE"
  },
  {
    "identifier": "CP_QR_PRESS_HOLD",
    "source_string": "Press & hold",
    "translation": "Press & hold",
    "context": " -> CP_QR_PRESS_HOLD"
  },
  {
    "identifier": "CP_QR_SCAN_TEXT",
    "source_string": "Press and hold the QR code below to save it. It will be scanned later so you can receive your Event Recordings",
    "translation": "Press and hold the QR code below to save it. It will be scanned later so you can receive your Event Recordings",
    "context": " -> CP_QR_SCAN_TEXT"
  },
  {
    "identifier": "CP_REFRESH_BTN",
    "source_string": "Reload",
    "translation": "Reload",
    "context": " -> CP_REFRESH_BTN"
  },
  {
    "identifier": "CP_RSP_REDIRECT_EVENT_APP_HEADING",
    "source_string": "Access your Event details",
    "translation": "Access your Event details",
    "context": " -> CP_RSP_REDIRECT_EVENT_APP_HEADING"
  },
  {
    "identifier": "CP_RSP_REDIRECT_EVENT_APP_SUBHEADING",
    "source_string": "To view the full event information, please use the Mercedes-Benz Stories App. Scan the QR code below with your smartphone to be taken directly to the event details or, if needed, to download the app.",
    "translation": "To view the full event information, please use the Mercedes-Benz Stories App. Scan the QR code below with your smartphone to be taken directly to the event details or, if needed, to download the app.",
    "context": " -> CP_RSP_REDIRECT_EVENT_APP_SUBHEADING"
  },
  {
    "identifier": "CP_RSP_VIEW_DETAILS_LINK",
    "source_string": "View Event details",
    "translation": "View Event details",
    "context": " -> CP_RSP_VIEW_DETAILS_LINK"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_APP_BUTTON",
    "source_string": "Go to App",
    "translation": "Go to App",
    "context": " -> CP_RSP_CREATE_STORY_APP_BUTTON"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_BACK_BUTTON",
    "source_string": "Back",
    "translation": "Back",
    "context": " -> CP_RSP_CREATE_STORY_BACK_BUTTON"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_BACK_LINK",
    "source_string": "Back",
    "translation": "Back",
    "context": " -> CP_RSP_CREATE_STORY_BACK_LINK"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_GARAGE_BACK_BUTTON",
    "source_string": "Back to Garage",
    "translation": "Back to Garage",
    "context": " -> CP_RSP_CREATE_STORY_GARAGE_BACK_BUTTON"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_NEW",
    "source_string": "Create a new Story",
    "translation": "Create a new Story",
    "context": " -> CP_RSP_CREATE_STORY_NEW"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_PUBLISH_NOTIFICATION",
    "source_string": "Experience has been published",
    "translation": "Experience has been published",
    "context": " -> CP_RSP_CREATE_STORY_PUBLISH_NOTIFICATION"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_SHARE _TEXT",
    "source_string": "Share your Event experiences via the Mercedes-Benz Stories app. You can easily edit and enhance your Story's  content using your smartphone - for example, by adding more photos.",
    "translation": "Share your Event experiences via the Mercedes-Benz Stories app. You can easily edit and enhance your Story's  content using your smartphone - for example, by adding more photos.",
    "context": " -> CP_RSP_CREATE_STORY_SHARE _TEXT"
  },
  {
    "identifier": "CP_RSP_CREATE_STORY_TEXT",
    "source_string": "Create Story",
    "translation": "Create Story",
    "context": " -> CP_RSP_CREATE_STORY_TEXT"
  },
  {
    "identifier": "CP_RSP_DATA_DOWNLOAD_TEXT",
    "source_string": "EU Data Act Requiements, to access your data",
    "translation": "EU Data Act Requiements, to access your data",
    "context": " -> CP_RSP_DATA_DOWNLOAD_TEXT"
  },
  {
    "identifier": "CP_RSP_DATA_DOWNLOAD_TEXT_CLICK",
    "source_string": "click here",
    "translation": "click here",
    "context": " -> CP_RSP_DATA_DOWNLOAD_TEXT_CLICK"
  },
  {
    "identifier": "CP_RSP_LEADERBOARD_TITLE",
    "source_string": "Leaderboard",
    "translation": "Leaderboard",
    "context": " -> CP_RSP_LEADERBOARD_TITLE"
  },
  {
    "identifier": "CP_RSP_MEDIA_PLACEHOLDER",
    "source_string": "Good things take time: We are working on your video. As soon as it is available and ready to share, we will send you an e-mail.",
    "translation": "Good things take time: We are working on your video. As soon as it is available and ready to share, we will send you an e-mail.",
    "context": " -> CP_RSP_MEDIA_PLACEHOLDER"
  },
  {
    "identifier": "CP_RSP_RSPDOWNLOAD",
    "source_string": "Download",
    "translation": "Download",
    "context": " -> CP_RSP_RSPDOWNLOAD"
  },
  {
    "identifier": "CP_RSP_RSPEMOTIONALANIMATION",
    "source_string": "EMOTIONAL ANIMATION",
    "translation": "EMOTIONAL ANIMATION",
    "context": " -> CP_RSP_RSPEMOTIONALANIMATION"
  },
  {
    "identifier": "CP_RSP_RSPEMOTIONALVIDEO",
    "source_string": "EMOTIONAL VIDEO",
    "translation": "EMOTIONAL VIDEO",
    "context": " -> CP_RSP_RSPEMOTIONALVIDEO"
  },
  {
    "identifier": "CP_RSP_RSPHIGHLIGHTVIDEO",
    "source_string": "RECAP VIDEO",
    "translation": "RECAP VIDEO",
    "context": " -> CP_RSP_RSPHIGHLIGHTVIDEO"
  },
  {
    "identifier": "CP_RSP_RSPINSTASTORY",
    "source_string": "HIGHLIGHT VIDEO",
    "translation": "HIGHLIGHT VIDEO",
    "context": " -> CP_RSP_RSPINSTASTORY"
  },
  {
    "identifier": "CP_RSP_RSPMEDIADOWNLOAD",
    "source_string": "DOWNLOAD VIDEOS & DATA HERE",
    "translation": "DOWNLOAD VIDEOS & DATA HERE",
    "context": " -> CP_RSP_RSPMEDIADOWNLOAD"
  },
  {
    "identifier": "CP_RSP_RSPMEDIAHIGHLIGHT",
    "source_string": "RECAP",
    "translation": "RECAP",
    "context": " -> CP_RSP_RSPMEDIAHIGHLIGHT"
  },
  {
    "identifier": "CP_RSP_RSPMEDIAINSTA",
    "source_string": "HIGHLIGHT",
    "translation": "HIGHLIGHT",
    "context": " -> CP_RSP_RSPMEDIAINSTA"
  },
  {
    "identifier": "CP_RSP_RSPMEDIAORIGINAL",
    "source_string": "ORIGINAL",
    "translation": "ORIGINAL",
    "context": " -> CP_RSP_RSPMEDIAORIGINAL"
  },
  {
    "identifier": "CP_RSP_RSPMEDIASTORY",
    "source_string": "VIDEO",
    "translation": "VIDEO",
    "context": " -> CP_RSP_RSPMEDIASTORY"
  },
  {
    "identifier": "CP_RSP_RSPMEDIAVIDEO",
    "source_string": "VIDEO",
    "translation": "VIDEO",
    "context": " -> CP_RSP_RSPMEDIAVIDEO"
  },
  {
    "identifier": "CP_RSP_RSPNORACEVIDEO",
    "source_string": "Video Not Available",
    "translation": "Video Not Available",
    "context": " -> CP_RSP_RSPNORACEVIDEO"
  },
  {
    "identifier": "CP_RSP_RSPORIGINALHD",
    "source_string": "ORIGINAL HD",
    "translation": "ORIGINAL HD",
    "context": " -> CP_RSP_RSPORIGINALHD"
  },
  {
    "identifier": "CP_RSP_RSPOVERALLRANKING",
    "source_string": "Overall ranking",
    "translation": "Overall ranking",
    "context": " -> CP_RSP_RSPOVERALLRANKING"
  },
  {
    "identifier": "CP_RSP_RSPPUBLISHBUTTON",
    "source_string": "Publish",
    "translation": "Publish",
    "context": " -> CP_RSP_RSPPUBLISHBUTTON"
  },
  {
    "identifier": "CP_RSP_RSPPUBLISHSUCCESSMSG",
    "source_string": "Published successfully",
    "translation": "Published successfully",
    "context": " -> CP_RSP_RSPPUBLISHSUCCESSMSG"
  },
  {
    "identifier": "CP_RSP_RSPPUBLISHTITLE",
    "source_string": "Publish now, to share your experience",
    "translation": "Publish now, to share your experience",
    "context": " -> CP_RSP_RSPPUBLISHTITLE"
  },
  {
    "identifier": "CP_RSP_RSPSHAREYOURRACE",
    "source_string": "Share Your Race",
    "translation": "Share Your Race",
    "context": " -> CP_RSP_RSPSHAREYOURRACE"
  },
  {
    "identifier": "CP_RSP_RSPWATCHFULLSCREEN",
    "source_string": "Watch Fullscreen",
    "translation": "Watch Fullscreen",
    "context": " -> CP_RSP_RSPWATCHFULLSCREEN"
  },
  {
    "identifier": "CP_RSP_SPONSORED",
    "source_string": "Sponsored",
    "translation": "Sponsored",
    "context": " -> CP_RSP_SPONSORED"
  },
  {
    "identifier": "CP_SM_ACCELERATOR_PEDAL",
    "source_string": "Accelerator pedal",
    "translation": "Accelerator pedal",
    "context": " -> CP_SM_ACCELERATOR_PEDAL"
  },
  {
    "identifier": "CP_SM_ANONYMIZATION_CONFIRMATION",
    "source_string": "Are you sure you want to anonymize your data?",
    "translation": "Are you sure you want to anonymize your data?",
    "context": " -> CP_SM_ANONYMIZATION_CONFIRMATION"
  },
  {
    "identifier": "CP_SM_ANONYMIZATION_LB_RANKING",
    "source_string": "Event leaderboard",
    "translation": "Event leaderboard",
    "context": " -> CP_SM_ANONYMIZATION_LB_RANKING"
  },
  {
    "identifier": "CP_SM_ANONYMIZATION_POPUP_DESC",
    "source_string": "If you choose to anonymize your event data, please be aware that all information associated with your events will be lost. Data will be permanently removed and cannot be recovered.",
    "translation": "If you choose to anonymize your event data, please be aware that all information associated with your events will be lost. Data will be permanently removed and cannot be recovered.",
    "context": " -> CP_SM_ANONYMIZATION_POPUP_DESC"
  },
  {
    "identifier": "CP_SM_ANONYMIZATION_POPUP_TITLE",
    "source_string": "Anonymize event data",
    "translation": "Anonymize event data",
    "context": " -> CP_SM_ANONYMIZATION_POPUP_TITLE"
  },
  {
    "identifier": "CP_SM_ANONYMIZATION_RACE_DETAILS",
    "source_string": "Race details",
    "translation": "Race details",
    "context": " -> CP_SM_ANONYMIZATION_RACE_DETAILS"
  },
  {
    "identifier": "CP_SM_ANONYMIZATION_VIDEO_CONTENT",
    "source_string": "Video content",
    "translation": "Video content",
    "context": " -> CP_SM_ANONYMIZATION_VIDEO_CONTENT"
  },
  {
    "identifier": "CP_SM_ANONYMIZING",
    "source_string": "Anonymizing",
    "translation": "Anonymizing",
    "context": " -> CP_SM_ANONYMIZING"
  },
  {
    "identifier": "CP_SM_ASSET_GENERAYION_INPROGRESS",
    "source_string": "Your race details are still loading. Please check back shortly",
    "translation": "Your race details are still loading. Please check back shortly",
    "context": " -> CP_SM_ASSET_GENERAYION_INPROGRESS"
  },
  {
    "identifier": "CP_SM_BREAK_PEDAL_LBL",
    "source_string": "Brake pedal",
    "translation": "Brake pedal",
    "context": " -> CP_SM_BREAK_PEDAL_LBL"
  },
  {
    "identifier": "CP_SM_CANCEL",
    "source_string": "Cancel",
    "translation": "Cancel",
    "context": " -> CP_SM_CANCEL"
  },
  {
    "identifier": "CP_SM_CIAM_ANONYMIZED",
    "source_string": "User anonymised",
    "translation": "User anonymised",
    "context": " -> CP_SM_CIAM_ANONYMIZED"
  },
  {
    "identifier": "CP_SM_CIAM_ANONYMIZED_MESSAGE",
    "source_string": "You have anonymised your account. Unfortunately, deleted experiences can't be restored.",
    "translation": "You have anonymised your account. Unfortunately, deleted experiences can't be restored.",
    "context": " -> CP_SM_CIAM_ANONYMIZED_MESSAGE"
  },
  {
    "identifier": "CP_SM_CIAM_LINKED",
    "source_string": "User already linked",
    "translation": "User already linked",
    "context": " -> CP_SM_CIAM_LINKED"
  },
  {
    "identifier": "CP_SM_CIAM_LINKED_MESSAGE",
    "source_string": "This experience is already linked to another Mercedes me ID. Kindly reach out to the event administrator for further assistance.",
    "translation": "This experience is already linked to another Mercedes me ID. Kindly reach out to the event administrator for further assistance.",
    "context": " -> CP_SM_CIAM_LINKED_MESSAGE"
  },
  {
    "identifier": "CP_SM_CIAMCONFIRMPAGE_CONNECTMERCEDESMEID",
    "source_string": "Connect with other Mercedes me ID",
    "translation": "Connect with other Mercedes me ID",
    "context": " -> CP_SM_CIAMCONFIRMPAGE_CONNECTMERCEDESMEID"
  },
  {
    "identifier": "CP_SM_CIAMCONFIRMPAGE_EVENTNAME",
    "source_string": "Event name & date",
    "translation": "Event name & date",
    "context": " -> CP_SM_CIAMCONFIRMPAGE_EVENTNAME"
  },
  {
    "identifier": "CP_SM_CIAMCONFIRMPAGE_MERCEDESID",
    "source_string": "Your Mercedes me ID",
    "translation": "Your Mercedes me ID",
    "context": " -> CP_SM_CIAMCONFIRMPAGE_MERCEDESID"
  },
  {
    "identifier": "CP_SM_CIAMCONFIRMPAGE_MESSAGE",
    "source_string": "Please confirm the link between the mentioned event participation and Mercedes me ID below. All recordings of this event will be available for the given Mercedes me ID.",
    "translation": "Please confirm the link between the mentioned event participation and Mercedes me ID below. All recordings of this event will be available for the given Mercedes me ID.",
    "context": " -> CP_SM_CIAMCONFIRMPAGE_MESSAGE"
  },
  {
    "identifier": "CP_SM_CIAMCONFIRMPAGE_PARTICIPANTDETAILS",
    "source_string": "Event participation details",
    "translation": "Event participation details",
    "context": " -> CP_SM_CIAMCONFIRMPAGE_PARTICIPANTDETAILS"
  },
  {
    "identifier": "CP_SM_CIAMLINK_MESSAGE",
    "source_string": "Thank you for your participation in the event. You will be notified by E-Mail when your recording is ready. You can close this window now.",
    "translation": "Thank you for your participation in the event. You will be notified by E-Mail when your recording is ready. You can close this window now.",
    "context": " -> CP_SM_CIAMLINK_MESSAGE"
  },
  {
    "identifier": "CP_SM_CLOSE_BTN",
    "source_string": "Close",
    "translation": "Close",
    "context": " -> CP_SM_CLOSE_BTN"
  },
  {
    "identifier": "CP_SM_CONFIRM_BTN",
    "source_string": "Confirm",
    "translation": "Confirm",
    "context": " -> CP_SM_CONFIRM_BTN"
  },
  {
    "identifier": "CP_SM_DATA_ANONYMIZATION_FAIL_APP_MSG",
    "source_string": "Anonymization possible only on the App",
    "translation": "Anonymization possible only on the App",
    "context": " -> CP_SM_DATA_ANONYMIZATION_FAIL_APP_MSG"
  },
  {
    "identifier": "CP_SM_DATA_ANONYMIZATION_FAIL_APP_SUB_MSG",
    "source_string": "To anonymize your data, please follow these steps: Open the Mercedes-Benz Stories App > go to the \"My Stories\" page > navigate to the event car > tap \"Options\" in the top right of the recording > Choose \"Delete recording”. Your data will be anonymized.",
    "translation": "To anonymize your data, please follow these steps: Open the Mercedes-Benz Stories App > go to the \"My Stories\" page > navigate to the event car > tap \"Options\" in the top right of the recording > Choose \"Delete recording”. Your data will be anonymized.",
    "context": " -> CP_SM_DATA_ANONYMIZATION_FAIL_APP_SUB_MSG"
  },
  {
    "identifier": "CP_SM_DATA_ANONYMIZATION_FAIL_MSG",
    "source_string": "Event data anonymisation failed.",
    "translation": "Event data anonymisation failed.",
    "context": " -> CP_SM_DATA_ANONYMIZATION_FAIL_MSG"
  },
  {
    "identifier": "CP_SM_DATA_ANONYMIZED",
    "source_string": "Event data already anonymised",
    "translation": "Event data already anonymised",
    "context": " -> CP_SM_DATA_ANONYMIZED"
  },
  {
    "identifier": "CP_SM_DATA_ANONYMIZED_PARTICIPANT_NOT_FOUND",
    "source_string": "Participant not found",
    "translation": "Participant not found",
    "context": " -> CP_SM_DATA_ANONYMIZED_PARTICIPANT_NOT_FOUND"
  },
  {
    "identifier": "CP_SM_DATA_ANONYMIZED_SUCCESS",
    "source_string": "Event data anonymization was successful.",
    "translation": "Event data anonymization was successful.",
    "context": " -> CP_SM_DATA_ANONYMIZED_SUCCESS"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_CHARACTERLIMIT",
    "source_string": "Characters",
    "translation": "Characters",
    "context": " -> CP_SM_EDITPROFILE_CHARACTERLIMIT"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_DESCRIPTION",
    "source_string": "Description",
    "translation": "Description",
    "context": " -> CP_SM_EDITPROFILE_DESCRIPTION"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_MESSAGE",
    "source_string": "Introduce yourself to the community. These optional information will also update on your me Stories web and app profile.",
    "translation": "Introduce yourself to the community. These optional information will also update on your me Stories web and app profile.",
    "context": " -> CP_SM_EDITPROFILE_MESSAGE"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_NICKNAME",
    "source_string": "Nickname",
    "translation": "Nickname",
    "context": " -> CP_SM_EDITPROFILE_NICKNAME"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_SOCIALLINK",
    "source_string": "Social Link",
    "translation": "Social Link",
    "context": " -> CP_SM_EDITPROFILE_SOCIALLINK"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_SUBMESSAGE",
    "source_string": "To modify your Mercedes me account details, kindly visit the official Mercedes-Benz website.",
    "translation": "To modify your Mercedes me account details, kindly visit the official Mercedes-Benz website.",
    "context": " -> CP_SM_EDITPROFILE_SUBMESSAGE"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_UPDATE",
    "source_string": "Update",
    "translation": "Update",
    "context": " -> CP_SM_EDITPROFILE_UPDATE"
  },
  {
    "identifier": "CP_SM_EDITPROFILE_URLMESSAGE",
    "source_string": "Enter a URL that you can send to other users via their profile",
    "translation": "Enter a URL that you can send to other users via their profile",
    "context": " -> CP_SM_EDITPROFILE_URLMESSAGE"
  },
  {
    "identifier": "CP_SM_EVENTS_EMPTY_MSG",
    "source_string": "Grab this opportunity and explore upcoming Event dates on our pages. Can't find anything suitable in your region? Please ask your trusted dealer for recommendations.",
    "translation": "Grab this opportunity and explore upcoming Event dates on our pages. Can't find anything suitable in your region? Please ask your trusted dealer for recommendations.",
    "context": " -> CP_SM_EVENTS_EMPTY_MSG"
  },
  {
    "identifier": "CP_SM_EVENTS_GARAGE_NO_STORY_MSG_NOT_OWNER",
    "source_string": "The user has participated the event but did not share any personal impressions. Check out the event details in the Mercedes Benz Stories app to see what other users shared from this brand experience.",
    "translation": "The user has participated the event but did not share any personal impressions. Check out the event details in the Mercedes Benz Stories app to see what other users shared from this brand experience.",
    "context": " -> CP_SM_EVENTS_GARAGE_NO_STORY_MSG_NOT_OWNER"
  },
  {
    "identifier": "CP_SM_EVENTS_GARAGE_NO_STORY_MSG_OWNER",
    "source_string": "Go for it: Share your first Moment with the community. Go the the Mercedes Benz Stories app and select a special image that sums up your automotive lifestyle or shows your latest memory connected to your precious vehicle.",
    "translation": "Go for it: Share your first Moment with the community. Go the the Mercedes Benz Stories app and select a special image that sums up your automotive lifestyle or shows your latest memory connected to your precious vehicle.",
    "context": " -> CP_SM_EVENTS_GARAGE_NO_STORY_MSG_OWNER"
  },
  {
    "identifier": "CP_SM_EVENTS_HEADING",
    "source_string": "Events",
    "translation": "Events",
    "context": " -> CP_SM_EVENTS_HEADING"
  },
  {
    "identifier": "CP_SM_GARAGE_ABOUT",
    "source_string": "About",
    "translation": "About",
    "context": " -> CP_SM_GARAGE_ABOUT"
  },
  {
    "identifier": "CP_SM_GARAGE_EDIT_PROFILE",
    "source_string": "Edit profile",
    "translation": "Edit profile",
    "context": " -> CP_SM_GARAGE_EDIT_PROFILE"
  },
  {
    "identifier": "CP_SM_GARAGE_EXPERIENCE",
    "source_string": "Experience",
    "translation": "Experience",
    "context": " -> CP_SM_GARAGE_EXPERIENCE"
  },
  {
    "identifier": "CP_SM_GARAGE_EXPERIENCES",
    "source_string": "Experiences",
    "translation": "Experiences",
    "context": " -> CP_SM_GARAGE_EXPERIENCES"
  },
  {
    "identifier": "CP_SM_GARAGE_MOMENT",
    "source_string": "Moment",
    "translation": "Moment",
    "context": " -> CP_SM_GARAGE_MOMENT"
  },
  {
    "identifier": "CP_SM_GARAGE_MOMENTS",
    "source_string": "Moments",
    "translation": "Moments",
    "context": " -> CP_SM_GARAGE_MOMENTS"
  },
  {
    "identifier": "CP_SM_GARAGE_NO_STORY_MSG",
    "source_string": "There are no Stories from this car, yet. Use the Mercedes Benz Stories App to record a ride and publish the Recording. You can also use the app to publish a special Moment with your car.",
    "translation": "There are no Stories from this car, yet. Use the Mercedes Benz Stories App to record a ride and publish the Recording. You can also use the app to publish a special Moment with your car.",
    "context": " -> CP_SM_GARAGE_NO_STORY_MSG"
  },
  {
    "identifier": "CP_SM_GARAGE_OF_TEXT",
    "source_string": "of",
    "translation": "of",
    "context": " -> CP_SM_GARAGE_OF_TEXT"
  },
  {
    "identifier": "CP_SM_GARAGE_SHARE_PROFILE",
    "source_string": "Share profile",
    "translation": "Share profile",
    "context": " -> CP_SM_GARAGE_SHARE_PROFILE"
  },
  {
    "identifier": "CP_SM_GARAGE_SOCIAL",
    "source_string": "Social",
    "translation": "Social",
    "context": " -> CP_SM_GARAGE_SOCIAL"
  },
  {
    "identifier": "CP_SM_GO_TO_APP_BTN",
    "source_string": "Go to App",
    "translation": "Go to App",
    "context": " -> CP_SM_GO_TO_APP_BTN"
  },
  {
    "identifier": "CP_SM_LEADERBOARD_BTN_LBL",
    "source_string": "Go to leaderboard",
    "translation": "Go to leaderboard",
    "context": " -> CP_SM_LEADERBOARD_BTN_LBL"
  },
  {
    "identifier": "CP_SM_MINS_TEXT",
    "source_string": "min.",
    "translation": "min.",
    "context": " -> CP_SM_MINS_TEXT"
  },
  {
    "identifier": "CP_SM_NO_VEHICLE_MSG",
    "source_string": "There are no vehicles in your Garage, yet. Use the Mercedes Benz Stories App to add a vehicle.",
    "translation": "There are no vehicles in your Garage, yet. Use the Mercedes Benz Stories App to add a vehicle.",
    "context": " -> CP_SM_NO_VEHICLE_MSG"
  },
  {
    "identifier": "CP_SM_NO_VEHICLE_SUB_MSG",
    "source_string": "Nothing recorded yet",
    "translation": "Nothing recorded yet",
    "context": " -> CP_SM_NO_VEHICLE_SUB_MSG"
  },
  {
    "identifier": "CP_SM_NO_VEHICLE_TITLE",
    "source_string": "No vehicle",
    "translation": "No vehicle",
    "context": " -> CP_SM_NO_VEHICLE_TITLE"
  },
  {
    "identifier": "CP_SM_OFFROAD_TITLE",
    "source_string": "Offroad Track",
    "translation": "Offroad Track",
    "context": " -> CP_SM_OFFROAD_TITLE"
  },
  {
    "identifier": "CP_SM_OK",
    "source_string": "Okay",
    "translation": "Okay",
    "context": " -> CP_SM_OK"
  },
  {
    "identifier": "CP_SM_ONGOING_EVENT_TITLE",
    "source_string": "Live event",
    "translation": "Live event",
    "context": " -> CP_SM_ONGOING_EVENT_TITLE"
  },
  {
    "identifier": "CP_SM_PTS_TEXT",
    "source_string": "pts.",
    "translation": "pts.",
    "context": " -> CP_SM_PTS_TEXT"
  },
  {
    "identifier": "CP_SM_REGISTER_MSG",
    "source_string": "Be aware others can see your full name.",
    "translation": "Be aware others can see your full name.",
    "context": " -> CP_SM_REGISTER_MSG"
  },
  {
    "identifier": "CP_SM_REGISTER_NAME_MSG",
    "source_string": "If you want to change your name, please do this in the account settings of your Mercedes me ID.",
    "translation": "If you want to change your name, please do this in the account settings of your Mercedes me ID.",
    "context": " -> CP_SM_REGISTER_NAME_MSG"
  },
  {
    "identifier": "CP_SM_REGISTER_RESPONSE_SUB_MSG",
    "source_string": "Please contact event admin for further steps and concerns.",
    "translation": "Please contact event admin for further steps and concerns.",
    "context": " -> CP_SM_REGISTER_RESPONSE_SUB_MSG"
  },
  {
    "identifier": "CP_SM_SECONDS_TEXT",
    "source_string": "s",
    "translation": "s",
    "context": " -> CP_SM_SECONDS_TEXT"
  },
  {
    "identifier": "CP_SM_SELF_REG_ACCEPT_MSG",
    "source_string": "I accept the",
    "translation": "I accept the",
    "context": " -> CP_SM_SELF_REG_ACCEPT_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_ACCEPT_MSG_COMPLETE",
    "source_string": "Please accept the privacy statement",
    "translation": "Please accept the privacy statement",
    "context": " -> CP_SM_SELF_REG_ACCEPT_MSG_COMPLETE"
  },
  {
    "identifier": "CP_SM_SELF_REG_ACCEPT_MSG_TERMS",
    "source_string": "privacy statement",
    "translation": "privacy statement",
    "context": " -> CP_SM_SELF_REG_ACCEPT_MSG_TERMS"
  },
  {
    "identifier": "CP_SM_SELF_REG_BUTTON_MSG",
    "source_string": "Check in with Mercedes me ID",
    "translation": "Check in with Mercedes me ID",
    "context": " -> CP_SM_SELF_REG_BUTTON_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_CHECKIN",
    "source_string": "Event check-in",
    "translation": "Event check-in",
    "context": " -> CP_SM_SELF_REG_CHECKIN"
  },
  {
    "identifier": "CP_SM_SELF_REG_CONFIRM_BUTTON_MSG",
    "source_string": "Confirm check-in",
    "translation": "Confirm check-in",
    "context": " -> CP_SM_SELF_REG_CONFIRM_BUTTON_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_DATE",
    "source_string": "Date",
    "translation": "Date",
    "context": " -> CP_SM_SELF_REG_DATE"
  },
  {
    "identifier": "CP_SM_SELF_REG_DIFF_USER_MSG",
    "source_string": "Use a different Mercedes me ID",
    "translation": "Use a different Mercedes me ID",
    "context": " -> CP_SM_SELF_REG_DIFF_USER_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_EMAIL",
    "source_string": "E-Mail",
    "translation": "E-Mail",
    "context": " -> CP_SM_SELF_REG_EMAIL"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG",
    "source_string": "Sorry, this check-in leads nowhere.",
    "translation": "Sorry, this check-in leads nowhere.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1003",
    "source_string": "Requested event not found.",
    "translation": "Requested event not found.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1003"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1004",
    "source_string": "Past Events cannot be modified.",
    "translation": "Past Events cannot be modified.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1004"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1403",
    "source_string": "Participant is not registered for the event.",
    "translation": "Participant is not registered for the event.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1403"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1408",
    "source_string": "Anonymous Participant.",
    "translation": "Anonymous Participant.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1408"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1412",
    "source_string": "CIAM ID was already registered to this event.",
    "translation": "CIAM ID was already registered to this event.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1412"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1413",
    "source_string": "Participant failed to store in DB.",
    "translation": "Participant failed to store in DB.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1413"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1901",
    "source_string": "Internal server error",
    "translation": "Internal server error",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1901"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1923",
    "source_string": "CIAM ID not present in token.",
    "translation": "CIAM ID not present in token.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1923"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1928",
    "source_string": "user not found in cognito ciam user pool.",
    "translation": "user not found in cognito ciam user pool.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1928"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1930",
    "source_string": "Different CIAM Account Linked.",
    "translation": "Different CIAM Account Linked.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1930"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1931",
    "source_string": "Country Code not present in token.",
    "translation": "Country Code not present in token.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1931"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_1934",
    "source_string": "CIAM linking failed.",
    "translation": "CIAM linking failed.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_1934"
  },
  {
    "identifier": "CP_SM_SELF_REG_ERROR_MSG_DEFAULT",
    "source_string": "Something went wrong.",
    "translation": "Something went wrong.",
    "context": " -> CP_SM_SELF_REG_ERROR_MSG_DEFAULT"
  },
  {
    "identifier": "CP_SM_SELF_REG_EVENT",
    "source_string": "Event",
    "translation": "Event",
    "context": " -> CP_SM_SELF_REG_EVENT"
  },
  {
    "identifier": "CP_SM_SELF_REG_HELLO",
    "source_string": "Hello!",
    "translation": "Hello!",
    "context": " -> CP_SM_SELF_REG_HELLO"
  },
  {
    "identifier": "CP_SM_SELF_REG_MERCEDES_ID",
    "source_string": "Mercedes me ID",
    "translation": "Mercedes me ID",
    "context": " -> CP_SM_SELF_REG_MERCEDES_ID"
  },
  {
    "identifier": "CP_SM_SELF_REG_MSG",
    "source_string": "Already registered for this event.",
    "translation": "Already registered for this event.",
    "context": " -> CP_SM_SELF_REG_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_PARA1",
    "source_string": "By checking in, your Mercedes me ID will be connected to your event credentials. After that, you can enjoy the following benefits:",
    "translation": "By checking in, your Mercedes me ID will be connected to your event credentials. After that, you can enjoy the following benefits:",
    "context": " -> CP_SM_SELF_REG_PARA1"
  },
  {
    "identifier": "CP_SM_SELF_REG_PARA2",
    "source_string": "Receive all event recordings for the connected Mercedes me ID",
    "translation": "Receive all event recordings for the connected Mercedes me ID",
    "context": " -> CP_SM_SELF_REG_PARA2"
  },
  {
    "identifier": "CP_SM_SELF_REG_PARA3",
    "source_string": "Access all event details and get updates in your Mercedes-Benz Stories app",
    "translation": "Access all event details and get updates in your Mercedes-Benz Stories app",
    "context": " -> CP_SM_SELF_REG_PARA3"
  },
  {
    "identifier": "CP_SM_SELF_REG_PARA4",
    "source_string": "Publish and share personal moments in your Mercedes-Benz Stories app",
    "translation": "Publish and share personal moments in your Mercedes-Benz Stories app",
    "context": " -> CP_SM_SELF_REG_PARA4"
  },
  {
    "identifier": "CP_SM_SELF_REG_PARA5",
    "source_string": "Additionally, all event updates will reach you via the E-Mail address connected to your Mercedes-Benz ID",
    "translation": "Additionally, all event updates will reach you via the E-Mail address connected to your Mercedes-Benz ID",
    "context": " -> CP_SM_SELF_REG_PARA5"
  },
  {
    "identifier": "CP_SM_SELF_REG_PARTICIPANT",
    "source_string": "Participant",
    "translation": "Participant",
    "context": " -> CP_SM_SELF_REG_PARTICIPANT"
  },
  {
    "identifier": "CP_SM_SELF_REG_SUCCESS_MSG",
    "source_string": "Event registration successful.",
    "translation": "Event registration successful.",
    "context": " -> CP_SM_SELF_REG_SUCCESS_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_WELCOME_MSG",
    "source_string": "Welcome to your Event.",
    "translation": "Welcome to your Event.",
    "context": " -> CP_SM_SELF_REG_WELCOME_MSG"
  },
  {
    "identifier": "CP_SM_SELFREGISTER_EVENTNAME",
    "source_string": "Event name",
    "translation": "Event name",
    "context": " -> CP_SM_SELFREGISTER_EVENTNAME"
  },
  {
    "identifier": "CP_SM_SELFREGISTER_PARTICIPANTFNAME",
    "source_string": "First name",
    "translation": "First name",
    "context": " -> CP_SM_SELFREGISTER_PARTICIPANTFNAME"
  },
  {
    "identifier": "CP_SM_SELFREGISTER_PARTICIPANTLNAME",
    "source_string": "Second name",
    "translation": "Second name",
    "context": " -> CP_SM_SELFREGISTER_PARTICIPANTLNAME"
  },
  {
    "identifier": "CP_SM_SENSITIVE_IMG_LBL",
    "source_string": "This photo may contain content that some people might find upsetting.",
    "translation": "This photo may contain content that some people might find upsetting.",
    "context": " -> CP_SM_SENSITIVE_IMG_LBL"
  },
  {
    "identifier": "CP_SM_SENSITIVE_SEE_PHOTO",
    "source_string": "See photo",
    "translation": "See photo",
    "context": " -> CP_SM_SENSITIVE_SEE_PHOTO"
  },
  {
    "identifier": "CP_SM_SHARE_LINK",
    "source_string": "Share link",
    "translation": "Share link",
    "context": " -> CP_SM_SHARE_LINK"
  },
  {
    "identifier": "CP_SM_SPEED_LBL",
    "source_string": "Speed",
    "translation": "Speed",
    "context": " -> CP_SM_SPEED_LBL"
  },
  {
    "identifier": "CP_SM_TERMS_CONDITIONS",
    "source_string": "I accept terms & conditions",
    "translation": "I accept terms & conditions",
    "context": " -> CP_SM_TERMS_CONDITIONS"
  },
  {
    "identifier": "CP_SM_TOAST_MSG_DESC_ERR",
    "source_string": "Description should be within 300 characters",
    "translation": "Description should be within 300 characters",
    "context": " -> CP_SM_TOAST_MSG_DESC_ERR"
  },
  {
    "identifier": "CP_SM_TOAST_MSG_NICKNAME_ERR ",
    "source_string": "Nickname should be within 64 characters",
    "translation": "Nickname should be within 64 characters",
    "context": " -> CP_SM_TOAST_MSG_NICKNAME_ERR "
  },
  {
    "identifier": "CP_SM_TOAST_MSG_NICKNAME_ERR",
    "source_string": "The nick name should be within 64 characters",
    "translation": "The nick name should be within 64 characters",
    "context": " -> CP_SM_TOAST_MSG_NICKNAME_ERR"
  },
  {
    "identifier": "CP_SM_TOAST_MSG_SOCLNK_ERR",
    "source_string": "Social Link should be within 300 characters",
    "translation": "Social Link should be within 300 characters",
    "context": " -> CP_SM_TOAST_MSG_SOCLNK_ERR"
  },
  {
    "identifier": "CP_SM_TOAST_MSG_SOCLNK_INVALID",
    "source_string": "Social Link is invalid",
    "translation": "Social Link is invalid",
    "context": " -> CP_SM_TOAST_MSG_SOCLNK_INVALID"
  },
  {
    "identifier": "CP_SM_TOAST_MSG_SUCCESS",
    "source_string": " Update Successful",
    "translation": " Update Successful",
    "context": " -> CP_SM_TOAST_MSG_SUCCESS"
  },
  {
    "identifier": "CP_SM_USER_NOT_FOUND",
    "source_string": "Page not available at this moment.",
    "translation": "Page not available at this moment.",
    "context": " -> CP_SM_USER_NOT_FOUND"
  },
  {
    "identifier": "CP_SM_VEHICLES_HEADING",
    "source_string": "Vehicles",
    "translation": "Vehicles",
    "context": " -> CP_SM_VEHICLES_HEADING"
  },
  {
    "identifier": "CP_SP_EXPLORE_AMG_EVENTS",
    "source_string": "Explore AMG Events",
    "translation": "Explore AMG Events",
    "context": " -> CP_SP_EXPLORE_AMG_EVENTS"
  },
  {
    "identifier": "CP_SP_EXPLORE_G_CLASS_EVENTS",
    "source_string": "Explore G-Class Events",
    "translation": "Explore G-Class Events",
    "context": " -> CP_SP_EXPLORE_G_CLASS_EVENTS"
  },
  {
    "identifier": "CP_SP_LOCAL_DEALERSHIP",
    "source_string": "Find a local dealership",
    "translation": "Find a local dealership",
    "context": " -> CP_SP_LOCAL_DEALERSHIP"
  },
  {
    "identifier": "CP_SP_NO_EVENTS_HEADING",
    "source_string": "New to our Events?",
    "translation": "New to our Events?",
    "context": " -> CP_SP_NO_EVENTS_HEADING"
  },
  {
    "identifier": "CP_THANK_YOU",
    "source_string": "Thank you! You are checked in, {placeholderOwnerName}.",
    "translation": "Thank you! You are checked in, {placeholderOwnerName}.",
    "context": " -> CP_THANK_YOU"
  },
  {
    "identifier": "CP_THANK_YOU_CHECKIN",
    "source_string": "Thank you! You are now checked in, {placeholderOwnerName}.",
    "translation": "Thank you! You are now checked in, {placeholderOwnerName}.",
    "context": " -> CP_THANK_YOU_CHECKIN"
  },
  {
    "identifier": "CP_TOAST_MSG_TEMPLOGIN_ERR",
    "source_string": "Incorrect credentials ",
    "translation": "Incorrect credentials ",
    "context": " -> CP_TOAST_MSG_TEMPLOGIN_ERR"
  },
  {
    "identifier": "NRSP_MAX_BRAKE_TORQUE",
    "source_string": "Max. brake torque",
    "translation": "Max. brake torque",
    "context": " -> NRSP_MAX_BRAKE_TORQUE"
  },
  {
    "identifier": "NRSP_MAX_GFORCE",
    "source_string": "Max. G-force",
    "translation": "Max. G-force",
    "context": " -> NRSP_MAX_GFORCE"
  },
  {
    "identifier": "NRSP_MAX_TIRE_TEMP",
    "source_string": "Max. tire temp",
    "translation": "Max. tire temp",
    "context": " -> NRSP_MAX_TIRE_TEMP"
  },
  {
    "identifier": "NRSP_TOP_SPEED",
    "source_string": "Top speed",
    "translation": "Top speed",
    "context": " -> NRSP_TOP_SPEED"
  },
  {
    "identifier": "RSP_404",
    "source_string": "Page not found",
    "translation": "Page not found",
    "context": " -> RSP_404"
  },
  {
    "identifier": "RSP_ACCESS_DENIED_MSG",
    "source_string": "To view this page, first register with \"Mercedes me\" or log in with your existing Mercedes me ID. The Mercedes me ID must be associated with your email address to get access to your race highlights.",
    "translation": "To view this page, first register with \"Mercedes me\" or log in with your existing Mercedes me ID. The Mercedes me ID must be associated with your email address to get access to your race highlights.",
    "context": " -> RSP_ACCESS_DENIED_MSG"
  },
  {
    "identifier": "RSP_ACCESS_DENIED_TITLE",
    "source_string": "Access Denied",
    "translation": "Access Denied",
    "context": " -> RSP_ACCESS_DENIED_TITLE"
  },
  {
    "identifier": "RSP_AIR_TEMP",
    "source_string": "Temperature",
    "translation": "Temperature",
    "context": " -> RSP_AIR_TEMP"
  },
  {
    "identifier": "RSP_BACK",
    "source_string": "Back",
    "translation": "Back",
    "context": " -> RSP_BACK"
  },
  {
    "identifier": "RSP_CONTENT_NOT_FOUND",
    "source_string": "Sorry, we are unable to load content at the moment. Please try reloading the page.",
    "translation": "Sorry, we are unable to load content at the moment. Please try reloading the page.",
    "context": " -> RSP_CONTENT_NOT_FOUND"
  },
  {
    "identifier": "RSP_CUSTOMER_HIGHLIGHT_WITH_NAME",
    "source_string": "{param}'s highlights",
    "translation": "{param}'s highlights",
    "context": " -> RSP_CUSTOMER_HIGHLIGHT_WITH_NAME"
  },
  {
    "identifier": "RSP_CUSTOMER_RIDE_WITH_NAME",
    "source_string": "{param}'s ride",
    "translation": "{param}'s ride",
    "context": " -> RSP_CUSTOMER_RIDE_WITH_NAME"
  },
  {
    "identifier": "RSP_DASHCAM",
    "source_string": "Dashcam",
    "translation": "Dashcam",
    "context": " -> RSP_DASHCAM"
  },
  {
    "identifier": "RSP_DOWNLOAD_ALL",
    "source_string": "Download all",
    "translation": "Download all",
    "context": " -> RSP_DOWNLOAD_ALL"
  },
  {
    "identifier": "RSP_DRIFT_ANGLE",
    "source_string": "Max drift angle",
    "translation": "Max drift angle",
    "context": " -> RSP_DRIFT_ANGLE"
  },
  {
    "identifier": "RSP_DRIFT_DISTANCE",
    "source_string": "Drift distance",
    "translation": "Drift distance",
    "context": " -> RSP_DRIFT_DISTANCE"
  },
  {
    "identifier": "RSP_DRIFT_SCORE",
    "source_string": "Drift Score",
    "translation": "Drift Score",
    "context": " -> RSP_DRIFT_SCORE"
  },
  {
    "identifier": "RSP_DRIFT_SPEED",
    "source_string": "Max. drift speed",
    "translation": "Max. drift speed",
    "context": " -> RSP_DRIFT_SPEED"
  },
  {
    "identifier": "RSP_ERR_PUBLISH_EXP",
    "source_string": "An error occured. Please try again later.",
    "translation": "An error occured. Please try again later.",
    "context": " -> RSP_ERR_PUBLISH_EXP"
  },
  {
    "identifier": "RSP_ERROR_HEADING",
    "source_string": "We didn't mean to desert you.",
    "translation": "We didn't mean to desert you.",
    "context": " -> RSP_ERROR_HEADING"
  },
  {
    "identifier": "RSP_ERROR_MSG",
    "source_string": "This Experience content has not been published yet. How about collecting your own Experiences instead?",
    "translation": "This Experience content has not been published yet. How about collecting your own Experiences instead?",
    "context": " -> RSP_ERROR_MSG"
  },
  {
    "identifier": "RSP_EVENT_EXPERIENCE_BY",
    "source_string": "Story by <strong>{placeholderProfileName}</strong>",
    "translation": "Story by <strong>{placeholderProfileName}</strong>",
    "context": " -> RSP_EVENT_EXPERIENCE_BY"
  },
  {
    "identifier": "RSP_EVENT_OWNER_WITH_BUSINESS_OWNER",
    "source_string": "<strong>{placeholderOwnerName}</strong> with <strong>{placeholderBusinessGroup}</strong>",
    "translation": "<strong>{placeholderOwnerName}</strong> with <strong>{placeholderBusinessGroup}</strong>",
    "context": " -> RSP_EVENT_OWNER_WITH_BUSINESS_OWNER"
  },
  {
    "identifier": "RSP_HIGHLIGHT",
    "source_string": "Highlight",
    "translation": "Highlight",
    "context": " -> RSP_HIGHLIGHT"
  },
  {
    "identifier": "RSP_HOTLAP",
    "source_string": "Recap",
    "translation": "Recap",
    "context": " -> RSP_HOTLAP"
  },
  {
    "identifier": "RSP_IMPRESSIONS",
    "source_string": "Impressions",
    "translation": "Impressions",
    "context": " -> RSP_IMPRESSIONS"
  },
  {
    "identifier": "RSP_INCLINE_ANGLE",
    "source_string": "Max inclination",
    "translation": "Max inclination",
    "context": " -> RSP_INCLINE_ANGLE"
  },
  {
    "identifier": "RSP_INFO_MSG",
    "source_string": " This page is currently private and only visible for you. Publish it now so others can relive your unique Experience.",
    "translation": " This page is currently private and only visible for you. Publish it now so others can relive your unique Experience.",
    "context": " -> RSP_INFO_MSG"
  },
  {
    "identifier": "RSP_INFO_PUBLISH_TITLE",
    "source_string": "Publish Experience",
    "translation": "Publish Experience",
    "context": " -> RSP_INFO_PUBLISH_TITLE"
  },
  {
    "identifier": "RSP_INFO_TITLE",
    "source_string": "Share the Thrill",
    "translation": "Share the Thrill",
    "context": " -> RSP_INFO_TITLE"
  },
  {
    "identifier": "RSP_INVALID_ACCESS_MSG",
    "source_string": "You are not the owner of this race summary. <br /> The race summary you want to visit has not been shared publicly.",
    "translation": "You are not the owner of this race summary. <br /> The race summary you want to visit has not been shared publicly.",
    "context": " -> RSP_INVALID_ACCESS_MSG"
  },
  {
    "identifier": "RSP_LAP_COUNT",
    "source_string": "LAP COUNT",
    "translation": "LAP COUNT",
    "context": " -> RSP_LAP_COUNT"
  },
  {
    "identifier": "RSP_LOADING_LBL",
    "source_string": "Loading...",
    "translation": "Loading...",
    "context": " -> RSP_LOADING_LBL"
  },
  {
    "identifier": "RSP_LOGIN_BTN_LBL",
    "source_string": "Login/Register Now",
    "translation": "Login/Register Now",
    "context": " -> RSP_LOGIN_BTN_LBL"
  },
  {
    "identifier": "RSP_LOGIN_WITH_ANOTHER_ID",
    "source_string": "Login with your Mercedes me ID",
    "translation": "Login with your Mercedes me ID",
    "context": " -> RSP_LOGIN_WITH_ANOTHER_ID"
  },
  {
    "identifier": "RSP_MAX_BRAKE_TORQUE",
    "source_string": "MAX. BRAKE TORQUE",
    "translation": "MAX. BRAKE TORQUE",
    "context": " -> RSP_MAX_BRAKE_TORQUE"
  },
  {
    "identifier": "RSP_MAX_DRIFT_ANGLE",
    "source_string": "MAX. DRIFT ANGLE",
    "translation": "MAX. DRIFT ANGLE",
    "context": " -> RSP_MAX_DRIFT_ANGLE"
  },
  {
    "identifier": "RSP_MAX_GFORCE",
    "source_string": "MAX. G-FORCE",
    "translation": "MAX. G-FORCE",
    "context": " -> RSP_MAX_GFORCE"
  },
  {
    "identifier": "RSP_MAX_LAT_ACC",
    "source_string": "MAX. LATERAL ACC",
    "translation": "MAX. LATERAL ACC",
    "context": " -> RSP_MAX_LAT_ACC"
  },
  {
    "identifier": "RSP_MAX_LON_ACC",
    "source_string": "MAX LONGITUDAL ACC",
    "translation": "MAX LONGITUDAL ACC",
    "context": " -> RSP_MAX_LON_ACC"
  },
  {
    "identifier": "RSP_MAX_TIRE_TEMP",
    "source_string": "MAX. TIRE TEMP",
    "translation": "MAX. TIRE TEMP",
    "context": " -> RSP_MAX_TIRE_TEMP"
  },
  {
    "identifier": "RSP_MAX_TRANS_OIL_TEMP",
    "source_string": "MAX. TRANSMISSION OIL TEMP",
    "translation": "MAX. TRANSMISSION OIL TEMP",
    "context": " -> RSP_MAX_TRANS_OIL_TEMP"
  },
  {
    "identifier": "RSP_OFFROAD_EXPERIENCE_TITLE",
    "source_string": "<strong>{placeholderOwnerName}</strong> - Event Experience",
    "translation": "<strong>{placeholderOwnerName}</strong> - Event Experience",
    "context": " -> RSP_OFFROAD_EXPERIENCE_TITLE"
  },
  {
    "identifier": "RSP_ORIGINAL_RECORDING",
    "source_string": "Original recording",
    "translation": "Original recording",
    "context": " -> RSP_ORIGINAL_RECORDING"
  },
  {
    "identifier": "RSP_PERSONAL_RACE_SHARED_TITLE",
    "source_string": "<strong>{placeholderOwnerName}</strong> - Experience",
    "translation": "<strong>{placeholderOwnerName}</strong> - Experience",
    "context": " -> RSP_PERSONAL_RACE_SHARED_TITLE"
  },
  {
    "identifier": "RSP_POINTS",
    "source_string": "points",
    "translation": "points",
    "context": " -> RSP_POINTS"
  },
  {
    "identifier": "RSP_RACE_UNAVAILABLE",
    "source_string": "Race data not available.",
    "translation": "Race data not available.",
    "context": " -> RSP_RACE_UNAVAILABLE"
  },
  {
    "identifier": "RSP_RANKING",
    "source_string": "RANKING",
    "translation": "RANKING",
    "context": " -> RSP_RANKING"
  },
  {
    "identifier": "RSP_REFRESH_BTN",
    "source_string": "Refresh",
    "translation": "Refresh",
    "context": " -> RSP_REFRESH_BTN"
  },
  {
    "identifier": "RSP_SUCCESS_PUBLISH_EXP",
    "source_string": "Your Experience was successfully published.",
    "translation": "Your Experience was successfully published.",
    "context": " -> RSP_SUCCESS_PUBLISH_EXP"
  },
  {
    "identifier": "RSP_TIME",
    "source_string": "TIME",
    "translation": "TIME",
    "context": " -> RSP_TIME"
  },
  {
    "identifier": "RSP_TOP_SPEED",
    "source_string": "TOP SPEED",
    "translation": "TOP SPEED",
    "context": " -> RSP_TOP_SPEED"
  },
  {
    "identifier": "RSP_TRACK_AND_VEHICLE",
    "source_string": "Track and vehicle",
    "translation": "Track and vehicle",
    "context": " -> RSP_TRACK_AND_VEHICLE"
  },
  {
    "identifier": "RSP_VEHICLE",
    "source_string": "Vehicle",
    "translation": "Vehicle",
    "context": " -> RSP_VEHICLE"
  },
  {
    "identifier": "RSP_VEHICLE_SHAREEXPERIENCE",
    "source_string": "- Experience",
    "translation": "- Experience",
    "context": " -> RSP_VEHICLE_SHAREEXPERIENCE"
  },
  {
    "identifier": "RSP_VID_FROM_CHALLENGE",
    "source_string": "Videos from your challenge",
    "translation": "Videos from your challenge",
    "context": " -> RSP_VID_FROM_CHALLENGE"
  },
  {
    "identifier": "RSP_VIDEOS_FROM_YOUR_RACE",
    "source_string": "Videos",
    "translation": "Videos",
    "context": " -> RSP_VIDEOS_FROM_YOUR_RACE"
  },
  {
    "identifier": "RSP_YAW_RATE",
    "source_string": "Yaw rate",
    "translation": "Yaw rate",
    "context": " -> RSP_YAW_RATE"
  },
  {
    "identifier": "CP_SM_STEERING_ANGLE_LBL",
    "source_string": "Steering angle",
    "translation": "Steering angle",
    "context": " -> CP_SM_STEERING_ANGLE_LBL"
  },
  {
    "identifier": "CP_SM_TORQUE_LBL",
    "source_string": "Torque",
    "translation": "Torque",
    "context": " -> CP_SM_TORQUE_LBL"
  },
  {
    "identifier": "CP_SM_ENGINE_POWER_LBL",
    "source_string": "Engine power",
    "translation": "Engine power",
    "context": " -> CP_SM_ENGINE_POWER_LBL"
  },
  {
    "identifier": "BP_EM_EXERCISE_DRIFT",
    "source_string": "Drift",
    "translation": "Drift",
    "context": " -> BP_EM_EXERCISE_DRIFT"
  },
  {
    "identifier": "CP_SM_SELF_REG_UPLOAD_TERMS_COND_MSG",
    "source_string": "terms and conditions for this event",
    "translation": "terms and conditions for this event",
    "context": " -> CP_SM_SELF_REG_UPLOAD_TERMS_COND_MSG"
  },
  {
    "identifier": "CP_SM_SELF_REG_UPLOAD_TERMS_COND_MSG_COMPLETE",
    "source_string": "Please accept terms and conditions for this event",
    "translation": "Please accept terms and conditions for this event",
    "context": " -> CP_SM_SELF_REG_UPLOAD_TERMS_COND_MSG_COMPLETE"
  },
   {
    "identifier": "CP_SM_OPEN_IN_APP_BTN_TXT",
    "source_string": "Open in app",
    "translation": "Open in app",
    "context": " -> CP_SM_OPEN_IN_APP_BTN_TXT"
  }
]
